(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wafer", [], factory);
	else if(typeof exports === 'object')
		exports["wafer"] = factory();
	else
		root["wafer"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://s.yimg.com/aaq/wf/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "../../node_modules/core-js/es/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
var path = __webpack_require__("../../node_modules/core-js/internals/path.js");

module.exports = path.Array.from;


/***/ }),

/***/ "../../node_modules/core-js/es/map/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.group-by.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
var path = __webpack_require__("../../node_modules/core-js/internals/path.js");

module.exports = path.Map;


/***/ }),

/***/ "../../node_modules/core-js/es/promise/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("../../node_modules/core-js/modules/es.aggregate-error.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.all-settled.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.any.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.with-resolvers.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.finally.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
var path = __webpack_require__("../../node_modules/core-js/internals/path.js");

module.exports = path.Promise;


/***/ }),

/***/ "../../node_modules/core-js/es/symbol/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.has-instance.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.is-concat-spreadable.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.match.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.match-all.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.replace.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.search.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.species.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.split.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-string-tag.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.unscopables.js");
__webpack_require__("../../node_modules/core-js/modules/es.json.to-string-tag.js");
__webpack_require__("../../node_modules/core-js/modules/es.math.to-string-tag.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.to-string-tag.js");
var path = __webpack_require__("../../node_modules/core-js/internals/path.js");

module.exports = path.Symbol;


/***/ }),

/***/ "../../node_modules/core-js/internals/a-callable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var tryToString = __webpack_require__("../../node_modules/core-js/internals/try-to-string.js");

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "../../node_modules/core-js/internals/a-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isConstructor = __webpack_require__("../../node_modules/core-js/internals/is-constructor.js");
var tryToString = __webpack_require__("../../node_modules/core-js/internals/try-to-string.js");

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ "../../node_modules/core-js/internals/a-possible-prototype.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isPossiblePrototype = __webpack_require__("../../node_modules/core-js/internals/is-possible-prototype.js");

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ "../../node_modules/core-js/internals/add-to-unscopables.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var create = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var defineProperty = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js").f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/an-instance.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError('Incorrect invocation');
};


/***/ }),

/***/ "../../node_modules/core-js/internals/an-object.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-buffer-non-extensible.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});


/***/ }),

/***/ "../../node_modules/core-js/internals/array-from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var callWithSafeIterationClosing = __webpack_require__("../../node_modules/core-js/internals/call-with-safe-iteration-closing.js");
var isArrayIteratorMethod = __webpack_require__("../../node_modules/core-js/internals/is-array-iterator-method.js");
var isConstructor = __webpack_require__("../../node_modules/core-js/internals/is-constructor.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var createProperty = __webpack_require__("../../node_modules/core-js/internals/create-property.js");
var getIterator = __webpack_require__("../../node_modules/core-js/internals/get-iterator.js");
var getIteratorMethod = __webpack_require__("../../node_modules/core-js/internals/get-iterator-method.js");

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    result = IS_CONSTRUCTOR ? new this() : [];
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var toAbsoluteIndex = __webpack_require__("../../node_modules/core-js/internals/to-absolute-index.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-iteration.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var IndexedObject = __webpack_require__("../../node_modules/core-js/internals/indexed-object.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var arraySpeciesCreate = __webpack_require__("../../node_modules/core-js/internals/array-species-create.js");

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(self);
    var boundFunction = bind(callbackfn, that);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-method-has-species-support.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var V8_VERSION = __webpack_require__("../../node_modules/core-js/internals/engine-v8-version.js");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-slice.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

module.exports = uncurryThis([].slice);


/***/ }),

/***/ "../../node_modules/core-js/internals/array-species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__("../../node_modules/core-js/internals/is-array.js");
var isConstructor = __webpack_require__("../../node_modules/core-js/internals/is-constructor.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-species-create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var arraySpeciesConstructor = __webpack_require__("../../node_modules/core-js/internals/array-species-constructor.js");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/call-with-safe-iteration-closing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var iteratorClose = __webpack_require__("../../node_modules/core-js/internals/iterator-close.js");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/check-correctness-of-iteration.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/classof-raw.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/classof.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("../../node_modules/core-js/internals/to-string-tag-support.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var classofRaw = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/collection-strong.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var defineBuiltInAccessor = __webpack_require__("../../node_modules/core-js/internals/define-built-in-accessor.js");
var defineBuiltIns = __webpack_require__("../../node_modules/core-js/internals/define-built-ins.js");
var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");
var anInstance = __webpack_require__("../../node_modules/core-js/internals/an-instance.js");
var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var defineIterator = __webpack_require__("../../node_modules/core-js/internals/iterator-define.js");
var createIterResultObject = __webpack_require__("../../node_modules/core-js/internals/create-iter-result-object.js");
var setSpecies = __webpack_require__("../../node_modules/core-js/internals/set-species.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var fastKey = __webpack_require__("../../node_modules/core-js/internals/internal-metadata.js").fastKey;
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key === key) return entry;
      }
    };

    defineBuiltIns(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          entry = entry.next;
        }
        state.first = state.last = undefined;
        state.index = create(null);
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first === entry) state.first = next;
          if (state.last === entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineBuiltInAccessor(Prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return createIterResultObject(undefined, true);
      }
      // return step by kind
      if (kind === 'keys') return createIterResultObject(entry.key, false);
      if (kind === 'values') return createIterResultObject(entry.value, false);
      return createIterResultObject([entry.key, entry.value], false);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/collection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var isForced = __webpack_require__("../../node_modules/core-js/internals/is-forced.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var InternalMetadataModule = __webpack_require__("../../node_modules/core-js/internals/internal-metadata.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var anInstance = __webpack_require__("../../node_modules/core-js/internals/an-instance.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var checkCorrectnessOfIteration = __webpack_require__("../../node_modules/core-js/internals/check-correctness-of-iteration.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");
var inheritIfRequired = __webpack_require__("../../node_modules/core-js/internals/inherit-if-required.js");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY === 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY === 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, constructor: true, forced: Constructor !== NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/copy-constructor-properties.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var ownKeys = __webpack_require__("../../node_modules/core-js/internals/own-keys.js");
var getOwnPropertyDescriptorModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-descriptor.js");
var definePropertyModule = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/correct-prototype-getter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "../../node_modules/core-js/internals/create-iter-result-object.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ "../../node_modules/core-js/internals/create-non-enumerable-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var definePropertyModule = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");
var createPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/create-property-descriptor.js");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/create-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "../../node_modules/core-js/internals/create-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var definePropertyModule = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");
var createPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/create-property-descriptor.js");

module.exports = function (object, key, value) {
  if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/define-built-in-accessor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var makeBuiltIn = __webpack_require__("../../node_modules/core-js/internals/make-built-in.js");
var defineProperty = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/define-built-in.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var definePropertyModule = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");
var makeBuiltIn = __webpack_require__("../../node_modules/core-js/internals/make-built-in.js");
var defineGlobalProperty = __webpack_require__("../../node_modules/core-js/internals/define-global-property.js");

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/define-built-ins.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/define-global-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),

/***/ "../../node_modules/core-js/internals/document-create-element.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "../../node_modules/core-js/internals/does-not-exceed-safe-integer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-is-browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IS_DENO = __webpack_require__("../../node_modules/core-js/internals/engine-is-deno.js");
var IS_NODE = __webpack_require__("../../node_modules/core-js/internals/engine-is-node.js");

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-is-deno.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-is-ios-pebble.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__("../../node_modules/core-js/internals/engine-user-agent.js");

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-is-ios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__("../../node_modules/core-js/internals/engine-user-agent.js");

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-is-node.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");

module.exports = classof(global.process) === 'process';


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-is-webos-webkit.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__("../../node_modules/core-js/internals/engine-user-agent.js");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-user-agent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-v8-version.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var userAgent = __webpack_require__("../../node_modules/core-js/internals/engine-user-agent.js");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "../../node_modules/core-js/internals/enum-bug-keys.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "../../node_modules/core-js/internals/error-stack-clear.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/error-stack-install.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");
var clearErrorStack = __webpack_require__("../../node_modules/core-js/internals/error-stack-clear.js");
var ERROR_STACK_INSTALLABLE = __webpack_require__("../../node_modules/core-js/internals/error-stack-installable.js");

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

module.exports = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/error-stack-installable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var createPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/create-property-descriptor.js");

module.exports = !fails(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ "../../node_modules/core-js/internals/export.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var getOwnPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var defineGlobalProperty = __webpack_require__("../../node_modules/core-js/internals/define-global-property.js");
var copyConstructorProperties = __webpack_require__("../../node_modules/core-js/internals/copy-constructor-properties.js");
var isForced = __webpack_require__("../../node_modules/core-js/internals/is-forced.js");

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = global[TARGET] && global[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/fails.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/freezing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "../../node_modules/core-js/internals/function-apply.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__("../../node_modules/core-js/internals/function-bind-native.js");

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "../../node_modules/core-js/internals/function-bind-context.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this-clause.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var NATIVE_BIND = __webpack_require__("../../node_modules/core-js/internals/function-bind-native.js");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "../../node_modules/core-js/internals/function-bind-native.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ "../../node_modules/core-js/internals/function-call.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__("../../node_modules/core-js/internals/function-bind-native.js");

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/function-name.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "../../node_modules/core-js/internals/function-uncurry-this-accessor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/function-uncurry-this-clause.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classofRaw = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/function-uncurry-this.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__("../../node_modules/core-js/internals/function-bind-native.js");

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "../../node_modules/core-js/internals/get-built-in.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "../../node_modules/core-js/internals/get-iterator-method.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__("../../node_modules/core-js/internals/classof.js");
var getMethod = __webpack_require__("../../node_modules/core-js/internals/get-method.js");
var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");
var Iterators = __webpack_require__("../../node_modules/core-js/internals/iterators.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ "../../node_modules/core-js/internals/get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var tryToString = __webpack_require__("../../node_modules/core-js/internals/try-to-string.js");
var getIteratorMethod = __webpack_require__("../../node_modules/core-js/internals/get-iterator-method.js");

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw new $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ "../../node_modules/core-js/internals/get-json-replacer-function.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var isArray = __webpack_require__("../../node_modules/core-js/internals/is-array.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};


/***/ }),

/***/ "../../node_modules/core-js/internals/get-method.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/global.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  check(typeof this == 'object' && this) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/core-js/internals/has-own-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/hidden-keys.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {};


/***/ }),

/***/ "../../node_modules/core-js/internals/host-report-errors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/html.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "../../node_modules/core-js/internals/ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var createElement = __webpack_require__("../../node_modules/core-js/internals/document-create-element.js");

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),

/***/ "../../node_modules/core-js/internals/indexed-object.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ "../../node_modules/core-js/internals/inherit-if-required.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var setPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-set-prototype-of.js");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/inspect-source.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var store = __webpack_require__("../../node_modules/core-js/internals/shared-store.js");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "../../node_modules/core-js/internals/install-error-cause.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/internal-metadata.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var hiddenKeys = __webpack_require__("../../node_modules/core-js/internals/hidden-keys.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var defineProperty = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js").f;
var getOwnPropertyNamesModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names.js");
var getOwnPropertyNamesExternalModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names-external.js");
var isExtensible = __webpack_require__("../../node_modules/core-js/internals/object-is-extensible.js");
var uid = __webpack_require__("../../node_modules/core-js/internals/uid.js");
var FREEZING = __webpack_require__("../../node_modules/core-js/internals/freezing.js");

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "../../node_modules/core-js/internals/internal-state.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__("../../node_modules/core-js/internals/weak-map-basic-detection.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var shared = __webpack_require__("../../node_modules/core-js/internals/shared-store.js");
var sharedKey = __webpack_require__("../../node_modules/core-js/internals/shared-key.js");
var hiddenKeys = __webpack_require__("../../node_modules/core-js/internals/hidden-keys.js");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-array-iterator-method.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var Iterators = __webpack_require__("../../node_modules/core-js/internals/iterators.js");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-array.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-callable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var inspectSource = __webpack_require__("../../node_modules/core-js/internals/inspect-source.js");

var noop = function () { /* empty */ };
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "../../node_modules/core-js/internals/is-forced.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "../../node_modules/core-js/internals/is-null-or-undefined.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-object.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-possible-prototype.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-pure.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = false;


/***/ }),

/***/ "../../node_modules/core-js/internals/is-symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");
var USE_SYMBOL_AS_UID = __webpack_require__("../../node_modules/core-js/internals/use-symbol-as-uid.js");

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ "../../node_modules/core-js/internals/iterate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var tryToString = __webpack_require__("../../node_modules/core-js/internals/try-to-string.js");
var isArrayIteratorMethod = __webpack_require__("../../node_modules/core-js/internals/is-array-iterator-method.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");
var getIterator = __webpack_require__("../../node_modules/core-js/internals/get-iterator.js");
var getIteratorMethod = __webpack_require__("../../node_modules/core-js/internals/get-iterator-method.js");
var iteratorClose = __webpack_require__("../../node_modules/core-js/internals/iterator-close.js");

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/iterator-close.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var getMethod = __webpack_require__("../../node_modules/core-js/internals/get-method.js");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/iterator-create-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("../../node_modules/core-js/internals/iterators-core.js").IteratorPrototype;
var create = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var createPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/create-property-descriptor.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");
var Iterators = __webpack_require__("../../node_modules/core-js/internals/iterators.js");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/iterator-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var FunctionName = __webpack_require__("../../node_modules/core-js/internals/function-name.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var createIteratorConstructor = __webpack_require__("../../node_modules/core-js/internals/iterator-create-constructor.js");
var getPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-get-prototype-of.js");
var setPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-set-prototype-of.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");
var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var Iterators = __webpack_require__("../../node_modules/core-js/internals/iterators.js");
var IteratorsCore = __webpack_require__("../../node_modules/core-js/internals/iterators-core.js");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/iterators-core.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var create = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var getPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-get-prototype-of.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "../../node_modules/core-js/internals/iterators.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {};


/***/ }),

/***/ "../../node_modules/core-js/internals/length-of-array-like.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toLength = __webpack_require__("../../node_modules/core-js/internals/to-length.js");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/make-built-in.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("../../node_modules/core-js/internals/function-name.js").CONFIGURABLE;
var inspectSource = __webpack_require__("../../node_modules/core-js/internals/inspect-source.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ "../../node_modules/core-js/internals/map-helpers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

// eslint-disable-next-line es/no-map -- safe
var MapPrototype = Map.prototype;

module.exports = {
  // eslint-disable-next-line es/no-map -- safe
  Map: Map,
  set: uncurryThis(MapPrototype.set),
  get: uncurryThis(MapPrototype.get),
  has: uncurryThis(MapPrototype.has),
  remove: uncurryThis(MapPrototype['delete']),
  proto: MapPrototype
};


/***/ }),

/***/ "../../node_modules/core-js/internals/math-trunc.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/microtask.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var safeGetBuiltIn = __webpack_require__("../../node_modules/core-js/internals/safe-get-built-in.js");
var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");
var macrotask = __webpack_require__("../../node_modules/core-js/internals/task.js").set;
var Queue = __webpack_require__("../../node_modules/core-js/internals/queue.js");
var IS_IOS = __webpack_require__("../../node_modules/core-js/internals/engine-is-ios.js");
var IS_IOS_PEBBLE = __webpack_require__("../../node_modules/core-js/internals/engine-is-ios-pebble.js");
var IS_WEBOS_WEBKIT = __webpack_require__("../../node_modules/core-js/internals/engine-is-webos-webkit.js");
var IS_NODE = __webpack_require__("../../node_modules/core-js/internals/engine-is-node.js");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
var microtask = safeGetBuiltIn('queueMicrotask');
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;


/***/ }),

/***/ "../../node_modules/core-js/internals/new-promise-capability.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/normalize-string-argument.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var objectKeys = __webpack_require__("../../node_modules/core-js/internals/object-keys.js");
var getOwnPropertySymbolsModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-symbols.js");
var propertyIsEnumerableModule = __webpack_require__("../../node_modules/core-js/internals/object-property-is-enumerable.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var IndexedObject = __webpack_require__("../../node_modules/core-js/internals/indexed-object.js");

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "../../node_modules/core-js/internals/object-create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var definePropertiesModule = __webpack_require__("../../node_modules/core-js/internals/object-define-properties.js");
var enumBugKeys = __webpack_require__("../../node_modules/core-js/internals/enum-bug-keys.js");
var hiddenKeys = __webpack_require__("../../node_modules/core-js/internals/hidden-keys.js");
var html = __webpack_require__("../../node_modules/core-js/internals/html.js");
var documentCreateElement = __webpack_require__("../../node_modules/core-js/internals/document-create-element.js");
var sharedKey = __webpack_require__("../../node_modules/core-js/internals/shared-key.js");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-define-properties.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("../../node_modules/core-js/internals/v8-prototype-define-bug.js");
var definePropertyModule = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var objectKeys = __webpack_require__("../../node_modules/core-js/internals/object-keys.js");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-define-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var IE8_DOM_DEFINE = __webpack_require__("../../node_modules/core-js/internals/ie8-dom-define.js");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("../../node_modules/core-js/internals/v8-prototype-define-bug.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var toPropertyKey = __webpack_require__("../../node_modules/core-js/internals/to-property-key.js");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var propertyIsEnumerableModule = __webpack_require__("../../node_modules/core-js/internals/object-property-is-enumerable.js");
var createPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/create-property-descriptor.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var toPropertyKey = __webpack_require__("../../node_modules/core-js/internals/to-property-key.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var IE8_DOM_DEFINE = __webpack_require__("../../node_modules/core-js/internals/ie8-dom-define.js");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-get-own-property-names-external.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var $getOwnPropertyNames = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names.js").f;
var arraySlice = __webpack_require__("../../node_modules/core-js/internals/array-slice.js");

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) === 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-get-own-property-names.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__("../../node_modules/core-js/internals/object-keys-internal.js");
var enumBugKeys = __webpack_require__("../../node_modules/core-js/internals/enum-bug-keys.js");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-get-own-property-symbols.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "../../node_modules/core-js/internals/object-get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var sharedKey = __webpack_require__("../../node_modules/core-js/internals/shared-key.js");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("../../node_modules/core-js/internals/correct-prototype-getter.js");

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-is-extensible.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__("../../node_modules/core-js/internals/array-buffer-non-extensible.js");

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;


/***/ }),

/***/ "../../node_modules/core-js/internals/object-is-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "../../node_modules/core-js/internals/object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var indexOf = __webpack_require__("../../node_modules/core-js/internals/array-includes.js").indexOf;
var hiddenKeys = __webpack_require__("../../node_modules/core-js/internals/hidden-keys.js");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__("../../node_modules/core-js/internals/object-keys-internal.js");
var enumBugKeys = __webpack_require__("../../node_modules/core-js/internals/enum-bug-keys.js");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-property-is-enumerable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "../../node_modules/core-js/internals/object-set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this-accessor.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");
var aPossiblePrototype = __webpack_require__("../../node_modules/core-js/internals/a-possible-prototype.js");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible(O);
    aPossiblePrototype(proto);
    if (!isObject(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "../../node_modules/core-js/internals/object-to-string.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("../../node_modules/core-js/internals/to-string-tag-support.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof.js");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "../../node_modules/core-js/internals/ordinary-to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "../../node_modules/core-js/internals/own-keys.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var getOwnPropertyNamesModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names.js");
var getOwnPropertySymbolsModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-symbols.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/path.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");

module.exports = global;


/***/ }),

/***/ "../../node_modules/core-js/internals/perform.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/promise-constructor-detection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var NativePromiseConstructor = __webpack_require__("../../node_modules/core-js/internals/promise-native-constructor.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isForced = __webpack_require__("../../node_modules/core-js/internals/is-forced.js");
var inspectSource = __webpack_require__("../../node_modules/core-js/internals/inspect-source.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var IS_BROWSER = __webpack_require__("../../node_modules/core-js/internals/engine-is-browser.js");
var IS_DENO = __webpack_require__("../../node_modules/core-js/internals/engine-is-deno.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var V8_VERSION = __webpack_require__("../../node_modules/core-js/internals/engine-v8-version.js");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ "../../node_modules/core-js/internals/promise-native-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");

module.exports = global.Promise;


/***/ }),

/***/ "../../node_modules/core-js/internals/promise-resolve.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var newPromiseCapability = __webpack_require__("../../node_modules/core-js/internals/new-promise-capability.js");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/promise-statics-incorrect-iteration.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NativePromiseConstructor = __webpack_require__("../../node_modules/core-js/internals/promise-native-constructor.js");
var checkCorrectnessOfIteration = __webpack_require__("../../node_modules/core-js/internals/check-correctness-of-iteration.js");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("../../node_modules/core-js/internals/promise-constructor-detection.js").CONSTRUCTOR;

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ "../../node_modules/core-js/internals/queue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ "../../node_modules/core-js/internals/require-object-coercible.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/safe-get-built-in.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
module.exports = function (name) {
  if (!DESCRIPTORS) return global[name];
  var descriptor = getOwnPropertyDescriptor(global, name);
  return descriptor && descriptor.value;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/set-species.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var defineBuiltInAccessor = __webpack_require__("../../node_modules/core-js/internals/define-built-in-accessor.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/set-to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js").f;
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared = __webpack_require__("../../node_modules/core-js/internals/shared.js");
var uid = __webpack_require__("../../node_modules/core-js/internals/uid.js");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "../../node_modules/core-js/internals/shared-store.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var globalThis = __webpack_require__("../../node_modules/core-js/internals/global.js");
var defineGlobalProperty = __webpack_require__("../../node_modules/core-js/internals/define-global-property.js");

var SHARED = '__core-js_shared__';
var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});

(store.versions || (store.versions = [])).push({
  version: '3.37.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.37.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ "../../node_modules/core-js/internals/shared.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var store = __webpack_require__("../../node_modules/core-js/internals/shared-store.js");

module.exports = function (key, value) {
  return store[key] || (store[key] = value || {});
};


/***/ }),

/***/ "../../node_modules/core-js/internals/species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var aConstructor = __webpack_require__("../../node_modules/core-js/internals/a-constructor.js");
var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/string-multibyte.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var toIntegerOrInfinity = __webpack_require__("../../node_modules/core-js/internals/to-integer-or-infinity.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "../../node_modules/core-js/internals/symbol-constructor-detection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("../../node_modules/core-js/internals/engine-v8-version.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "../../node_modules/core-js/internals/symbol-define-to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/symbol-registry-detection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_SYMBOL = __webpack_require__("../../node_modules/core-js/internals/symbol-constructor-detection.js");

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ "../../node_modules/core-js/internals/task.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var apply = __webpack_require__("../../node_modules/core-js/internals/function-apply.js");
var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var html = __webpack_require__("../../node_modules/core-js/internals/html.js");
var arraySlice = __webpack_require__("../../node_modules/core-js/internals/array-slice.js");
var createElement = __webpack_require__("../../node_modules/core-js/internals/document-create-element.js");
var validateArgumentsLength = __webpack_require__("../../node_modules/core-js/internals/validate-arguments-length.js");
var IS_IOS = __webpack_require__("../../node_modules/core-js/internals/engine-is-ios.js");
var IS_NODE = __webpack_require__("../../node_modules/core-js/internals/engine-is-node.js");

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__("../../node_modules/core-js/internals/to-integer-or-infinity.js");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-indexed-object.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("../../node_modules/core-js/internals/indexed-object.js");
var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-integer-or-infinity.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var trunc = __webpack_require__("../../node_modules/core-js/internals/math-trunc.js");

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-length.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__("../../node_modules/core-js/internals/to-integer-or-infinity.js");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-object.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var isSymbol = __webpack_require__("../../node_modules/core-js/internals/is-symbol.js");
var getMethod = __webpack_require__("../../node_modules/core-js/internals/get-method.js");
var ordinaryToPrimitive = __webpack_require__("../../node_modules/core-js/internals/ordinary-to-primitive.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-property-key.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("../../node_modules/core-js/internals/to-primitive.js");
var isSymbol = __webpack_require__("../../node_modules/core-js/internals/is-symbol.js");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-string-tag-support.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "../../node_modules/core-js/internals/to-string.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__("../../node_modules/core-js/internals/classof.js");

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/try-to-string.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/uid.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/use-symbol-as-uid.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("../../node_modules/core-js/internals/symbol-constructor-detection.js");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "../../node_modules/core-js/internals/v8-prototype-define-bug.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),

/***/ "../../node_modules/core-js/internals/validate-arguments-length.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/weak-map-basic-detection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ "../../node_modules/core-js/internals/well-known-symbol-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__("../../node_modules/core-js/internals/path.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var wrappedWellKnownSymbolModule = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-wrapped.js");
var defineProperty = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "../../node_modules/core-js/internals/well-known-symbol-wrapped.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "../../node_modules/core-js/internals/well-known-symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var shared = __webpack_require__("../../node_modules/core-js/internals/shared.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var uid = __webpack_require__("../../node_modules/core-js/internals/uid.js");
var NATIVE_SYMBOL = __webpack_require__("../../node_modules/core-js/internals/symbol-constructor-detection.js");
var USE_SYMBOL_AS_UID = __webpack_require__("../../node_modules/core-js/internals/use-symbol-as-uid.js");

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "../../node_modules/core-js/modules/es.aggregate-error.constructor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");
var getPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-get-prototype-of.js");
var setPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-set-prototype-of.js");
var copyConstructorProperties = __webpack_require__("../../node_modules/core-js/internals/copy-constructor-properties.js");
var create = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");
var createPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/create-property-descriptor.js");
var installErrorCause = __webpack_require__("../../node_modules/core-js/internals/install-error-cause.js");
var installErrorStack = __webpack_require__("../../node_modules/core-js/internals/error-stack-install.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var normalizeStringArgument = __webpack_require__("../../node_modules/core-js/internals/normalize-string-argument.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Error = Error;
var push = [].push;

var $AggregateError = function AggregateError(errors, message /* , options */) {
  var isInstance = isPrototypeOf(AggregateErrorPrototype, this);
  var that;
  if (setPrototypeOf) {
    that = setPrototypeOf(new $Error(), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
  } else {
    that = isInstance ? this : create(AggregateErrorPrototype);
    createNonEnumerableProperty(that, TO_STRING_TAG, 'Error');
  }
  if (message !== undefined) createNonEnumerableProperty(that, 'message', normalizeStringArgument(message));
  installErrorStack(that, $AggregateError, that.stack, 1);
  if (arguments.length > 2) installErrorCause(that, arguments[2]);
  var errorsArray = [];
  iterate(errors, push, { that: errorsArray });
  createNonEnumerableProperty(that, 'errors', errorsArray);
  return that;
};

if (setPrototypeOf) setPrototypeOf($AggregateError, $Error);
else copyConstructorProperties($AggregateError, $Error, { name: true });

var AggregateErrorPrototype = $AggregateError.prototype = create($Error.prototype, {
  constructor: createPropertyDescriptor(1, $AggregateError),
  message: createPropertyDescriptor(1, ''),
  name: createPropertyDescriptor(1, 'AggregateError')
});

// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$({ global: true, constructor: true, arity: 2 }, {
  AggregateError: $AggregateError
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.aggregate-error.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("../../node_modules/core-js/modules/es.aggregate-error.constructor.js");


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.concat.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isArray = __webpack_require__("../../node_modules/core-js/internals/is-array.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var doesNotExceedSafeInteger = __webpack_require__("../../node_modules/core-js/internals/does-not-exceed-safe-integer.js");
var createProperty = __webpack_require__("../../node_modules/core-js/internals/create-property.js");
var arraySpeciesCreate = __webpack_require__("../../node_modules/core-js/internals/array-species-create.js");
var arrayMethodHasSpeciesSupport = __webpack_require__("../../node_modules/core-js/internals/array-method-has-species-support.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var V8_VERSION = __webpack_require__("../../node_modules/core-js/internals/engine-v8-version.js");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var from = __webpack_require__("../../node_modules/core-js/internals/array-from.js");
var checkCorrectnessOfIteration = __webpack_require__("../../node_modules/core-js/internals/check-correctness-of-iteration.js");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var addToUnscopables = __webpack_require__("../../node_modules/core-js/internals/add-to-unscopables.js");
var Iterators = __webpack_require__("../../node_modules/core-js/internals/iterators.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");
var defineProperty = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js").f;
var defineIterator = __webpack_require__("../../node_modules/core-js/internals/iterator-define.js");
var createIterResultObject = __webpack_require__("../../node_modules/core-js/internals/create-iter-result-object.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ "../../node_modules/core-js/modules/es.json.stringify.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var apply = __webpack_require__("../../node_modules/core-js/internals/function-apply.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isSymbol = __webpack_require__("../../node_modules/core-js/internals/is-symbol.js");
var arraySlice = __webpack_require__("../../node_modules/core-js/internals/array-slice.js");
var getReplacerFunction = __webpack_require__("../../node_modules/core-js/internals/get-json-replacer-function.js");
var NATIVE_SYMBOL = __webpack_require__("../../node_modules/core-js/internals/symbol-constructor-detection.js");

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ "../../node_modules/core-js/modules/es.json.to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.map.constructor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__("../../node_modules/core-js/internals/collection.js");
var collectionStrong = __webpack_require__("../../node_modules/core-js/internals/collection-strong.js");

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.map.group-by.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var MapHelpers = __webpack_require__("../../node_modules/core-js/internals/map-helpers.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

var Map = MapHelpers.Map;
var has = MapHelpers.has;
var get = MapHelpers.get;
var set = MapHelpers.set;
var push = uncurryThis([].push);

var DOES_NOT_WORK_WITH_PRIMITIVES = IS_PURE || fails(function () {
  return Map.groupBy('ab', function (it) {
    return it;
  }).get('a').length !== 1;
});

// `Map.groupBy` method
// https://github.com/tc39/proposal-array-grouping
$({ target: 'Map', stat: true, forced: IS_PURE || DOES_NOT_WORK_WITH_PRIMITIVES }, {
  groupBy: function groupBy(items, callbackfn) {
    requireObjectCoercible(items);
    aCallable(callbackfn);
    var map = new Map();
    var k = 0;
    iterate(items, function (value) {
      var key = callbackfn(value, k++);
      if (!has(map, key)) set(map, key, [value]);
      else push(get(map, key), value);
    });
    return map;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("../../node_modules/core-js/modules/es.map.constructor.js");


/***/ }),

/***/ "../../node_modules/core-js/modules/es.math.to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var assign = __webpack_require__("../../node_modules/core-js/internals/object-assign.js");

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.get-own-property-symbols.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var NATIVE_SYMBOL = __webpack_require__("../../node_modules/core-js/internals/symbol-constructor-detection.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var getOwnPropertySymbolsModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-symbols.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.to-string.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("../../node_modules/core-js/internals/to-string-tag-support.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/object-to-string.js");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.all-settled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var newPromiseCapabilityModule = __webpack_require__("../../node_modules/core-js/internals/new-promise-capability.js");
var perform = __webpack_require__("../../node_modules/core-js/internals/perform.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("../../node_modules/core-js/internals/promise-statics-incorrect-iteration.js");

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.all.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var newPromiseCapabilityModule = __webpack_require__("../../node_modules/core-js/internals/new-promise-capability.js");
var perform = __webpack_require__("../../node_modules/core-js/internals/perform.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("../../node_modules/core-js/internals/promise-statics-incorrect-iteration.js");

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.any.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var newPromiseCapabilityModule = __webpack_require__("../../node_modules/core-js/internals/new-promise-capability.js");
var perform = __webpack_require__("../../node_modules/core-js/internals/perform.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("../../node_modules/core-js/internals/promise-statics-incorrect-iteration.js");

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  any: function any(iterable) {
    var C = this;
    var AggregateError = getBuiltIn('AggregateError');
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.catch.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("../../node_modules/core-js/internals/promise-constructor-detection.js").CONSTRUCTOR;
var NativePromiseConstructor = __webpack_require__("../../node_modules/core-js/internals/promise-native-constructor.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.constructor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var IS_NODE = __webpack_require__("../../node_modules/core-js/internals/engine-is-node.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var setPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-set-prototype-of.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");
var setSpecies = __webpack_require__("../../node_modules/core-js/internals/set-species.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var anInstance = __webpack_require__("../../node_modules/core-js/internals/an-instance.js");
var speciesConstructor = __webpack_require__("../../node_modules/core-js/internals/species-constructor.js");
var task = __webpack_require__("../../node_modules/core-js/internals/task.js").set;
var microtask = __webpack_require__("../../node_modules/core-js/internals/microtask.js");
var hostReportErrors = __webpack_require__("../../node_modules/core-js/internals/host-report-errors.js");
var perform = __webpack_require__("../../node_modules/core-js/internals/perform.js");
var Queue = __webpack_require__("../../node_modules/core-js/internals/queue.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");
var NativePromiseConstructor = __webpack_require__("../../node_modules/core-js/internals/promise-native-constructor.js");
var PromiseConstructorDetection = __webpack_require__("../../node_modules/core-js/internals/promise-constructor-detection.js");
var newPromiseCapabilityModule = __webpack_require__("../../node_modules/core-js/internals/new-promise-capability.js");

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.finally.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var NativePromiseConstructor = __webpack_require__("../../node_modules/core-js/internals/promise-native-constructor.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var speciesConstructor = __webpack_require__("../../node_modules/core-js/internals/species-constructor.js");
var promiseResolve = __webpack_require__("../../node_modules/core-js/internals/promise-resolve.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("../../node_modules/core-js/modules/es.promise.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.all.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.catch.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.race.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.reject.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.resolve.js");


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.race.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var newPromiseCapabilityModule = __webpack_require__("../../node_modules/core-js/internals/new-promise-capability.js");
var perform = __webpack_require__("../../node_modules/core-js/internals/perform.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("../../node_modules/core-js/internals/promise-statics-incorrect-iteration.js");

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.reject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var newPromiseCapabilityModule = __webpack_require__("../../node_modules/core-js/internals/new-promise-capability.js");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("../../node_modules/core-js/internals/promise-constructor-detection.js").CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.resolve.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var NativePromiseConstructor = __webpack_require__("../../node_modules/core-js/internals/promise-native-constructor.js");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("../../node_modules/core-js/internals/promise-constructor-detection.js").CONSTRUCTOR;
var promiseResolve = __webpack_require__("../../node_modules/core-js/internals/promise-resolve.js");

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.with-resolvers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var newPromiseCapabilityModule = __webpack_require__("../../node_modules/core-js/internals/new-promise-capability.js");

// `Promise.withResolvers` method
// https://github.com/tc39/proposal-promise-with-resolvers
$({ target: 'Promise', stat: true }, {
  withResolvers: function withResolvers() {
    var promiseCapability = newPromiseCapabilityModule.f(this);
    return {
      promise: promiseCapability.promise,
      resolve: promiseCapability.resolve,
      reject: promiseCapability.reject
    };
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.reflect.to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");

$({ global: true }, { Reflect: {} });

// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
setToStringTag(global.Reflect, 'Reflect', true);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.string.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("../../node_modules/core-js/internals/string-multibyte.js").charAt;
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");
var defineIterator = __webpack_require__("../../node_modules/core-js/internals/iterator-define.js");
var createIterResultObject = __webpack_require__("../../node_modules/core-js/internals/create-iter-result-object.js");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.async-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.constructor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var NATIVE_SYMBOL = __webpack_require__("../../node_modules/core-js/internals/symbol-constructor-detection.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var toPropertyKey = __webpack_require__("../../node_modules/core-js/internals/to-property-key.js");
var $toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var createPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/create-property-descriptor.js");
var nativeObjectCreate = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var objectKeys = __webpack_require__("../../node_modules/core-js/internals/object-keys.js");
var getOwnPropertyNamesModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names.js");
var getOwnPropertyNamesExternal = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names-external.js");
var getOwnPropertySymbolsModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-symbols.js");
var getOwnPropertyDescriptorModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-descriptor.js");
var definePropertyModule = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");
var definePropertiesModule = __webpack_require__("../../node_modules/core-js/internals/object-define-properties.js");
var propertyIsEnumerableModule = __webpack_require__("../../node_modules/core-js/internals/object-property-is-enumerable.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var defineBuiltInAccessor = __webpack_require__("../../node_modules/core-js/internals/define-built-in-accessor.js");
var shared = __webpack_require__("../../node_modules/core-js/internals/shared.js");
var sharedKey = __webpack_require__("../../node_modules/core-js/internals/shared-key.js");
var hiddenKeys = __webpack_require__("../../node_modules/core-js/internals/hidden-keys.js");
var uid = __webpack_require__("../../node_modules/core-js/internals/uid.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var wrappedWellKnownSymbolModule = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-wrapped.js");
var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");
var defineSymbolToPrimitive = __webpack_require__("../../node_modules/core-js/internals/symbol-define-to-primitive.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");
var $forEach = __webpack_require__("../../node_modules/core-js/internals/array-iteration.js").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var RangeError = global.RangeError;
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var fallbackDefineProperty = function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
};

var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a !== 7;
}) ? fallbackDefineProperty : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, nativeObjectCreate(null)));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw new TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      var $this = this === undefined ? global : this;
      if ($this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn($this, HIDDEN) && hasOwn($this[HIDDEN], tag)) $this[HIDDEN][tag] = false;
      var descriptor = createPropertyDescriptor(1, value);
      try {
        setSymbolDescriptor($this, tag, descriptor);
      } catch (error) {
        if (!(error instanceof RangeError)) throw error;
        fallbackDefineProperty($this, tag, descriptor);
      }
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.description.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var defineBuiltInAccessor = __webpack_require__("../../node_modules/core-js/internals/define-built-in-accessor.js");
var copyConstructorProperties = __webpack_require__("../../node_modules/core-js/internals/copy-constructor-properties.js");

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.for.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var shared = __webpack_require__("../../node_modules/core-js/internals/shared.js");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("../../node_modules/core-js/internals/symbol-registry-detection.js");

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.has-instance.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.is-concat-spreadable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol('isConcatSpreadable');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("../../node_modules/core-js/modules/es.symbol.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.for.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.key-for.js");
__webpack_require__("../../node_modules/core-js/modules/es.json.stringify.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-symbols.js");


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.key-for.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var isSymbol = __webpack_require__("../../node_modules/core-js/internals/is-symbol.js");
var tryToString = __webpack_require__("../../node_modules/core-js/internals/try-to-string.js");
var shared = __webpack_require__("../../node_modules/core-js/internals/shared.js");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("../../node_modules/core-js/internals/symbol-registry-detection.js");

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw new TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.match-all.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");

// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
defineWellKnownSymbol('matchAll');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.match.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.replace.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.search.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
defineWellKnownSymbol('search');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.species.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
defineWellKnownSymbol('species');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
defineWellKnownSymbol('split');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");
var defineSymbolToPrimitive = __webpack_require__("../../node_modules/core-js/internals/symbol-define-to-primitive.js");

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag(getBuiltIn('Symbol'), 'Symbol');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.unscopables.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');


/***/ }),

/***/ "../../node_modules/eligrey-classlist-js-polyfill/classList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * classList.js: Cross-browser full element.classList implementation.
 * 1.2.201711092
 *
 * By Eli Grey, http://eligrey.com
 * License: Dedicated to the public domain.
 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
 */
/* jshint bitwise: false */
if ("document" in self) {
	if (!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) {
		(function (view) {
			"use strict";

			if (!('Element' in view)) {
				return;
			}
			var classListProp = "classList",
			    protoProp = "prototype",
			    elemCtrProto = view.Element[protoProp],
			    objCtr = Object,
			    strTrim = String[protoProp].trim || function () {
				return this.replace(/^\s+|\s+$/g, "");
			},
			    arrIndexOf = Array[protoProp].indexOf || function (item) {
				var i = 0,
				    len = this.length;
				for (; i < len; i++) {
					if (i in this && this[i] === item) {
						return i;
					}
				}
				return -1;
			},
			    DOMEx = function DOMEx(type, message) {
				this.name = type;
				this.code = DOMException[type];
				this.message = message;
			},
			    checkTokenAndGetIndex = function checkTokenAndGetIndex(classList, token) {
				if (token === "") {
					throw new DOMEx("SYNTAX_ERR", "The token must not be empty.");
				}
				if (/\s/.test(token)) {
					throw new DOMEx("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
				}
				return arrIndexOf.call(classList, token);
			},
			    ClassList = function ClassList(elem) {
				var trimmedClasses = strTrim.call(elem.getAttribute("class") || ""),
				    classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [],
				    i = 0,
				    len = classes.length;
				for (; i < len; i++) {
					this.push(classes[i]);
				}
				this._updateClassName = function () {
					elem.setAttribute("class", this.toString());
				};
			},
			    classListProto = ClassList[protoProp] = [],
			    classListGetter = function classListGetter() {
				return new ClassList(this);
			};
			DOMEx[protoProp] = Error[protoProp];
			classListProto.item = function (i) {
				return this[i] || null;
			};
			classListProto.contains = function (token) {
				return !~checkTokenAndGetIndex(this, token + "");
			};
			classListProto.add = function () {
				var tokens = arguments,
				    i = 0,
				    l = tokens.length,
				    token,
				    updated = false;
				do {
					token = tokens[i] + "";
					if (~checkTokenAndGetIndex(this, token)) {
						this.push(token);
						updated = true;
					}
				} while (++i < l);
				if (updated) {
					this._updateClassName();
				}
			};
			classListProto.remove = function () {
				var tokens = arguments,
				    i = 0,
				    l = tokens.length,
				    token,
				    updated = false,
				    index;
				do {
					token = tokens[i] + "";
					index = checkTokenAndGetIndex(this, token);
					while (~index) {
						this.splice(index, 1);
						updated = true;
						index = checkTokenAndGetIndex(this, token);
					}
				} while (++i < l);
				if (updated) {
					this._updateClassName();
				}
			};
			classListProto.toggle = function (token, force) {
				var result = this.contains(token),
				    method = result ? force !== true && "remove" : force !== false && "add";
				if (method) {
					this[method](token);
				}
				if (force === true || force === false) {
					return force;
				} else {
					return !result;
				}
			};
			classListProto.replace = function (token, replacement_token) {
				var index = checkTokenAndGetIndex(token + "");
				if (~index) {
					this.splice(index, 1, replacement_token);
					this._updateClassName();
				}
			};
			classListProto.toString = function () {
				return this.join(" ");
			};
			if (objCtr.defineProperty) {
				var classListPropDesc = {
					get: classListGetter,
					enumerable: true,
					configurable: true
				};
				try {
					objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
				} catch (ex) {
					if (ex.number === undefined || ex.number === -0x7FF5EC54) {
						classListPropDesc.enumerable = false;
						objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
					}
				}
			} else if (objCtr[protoProp].__defineGetter__) {
				elemCtrProto.__defineGetter__(classListProp, classListGetter);
			}
		})(self);
	}
	(function () {
		"use strict";

		var testElement = document.createElement("_");
		testElement.classList.add("c1", "c2");
		if (!testElement.classList.contains("c2")) {
			var createMethod = function createMethod(method) {
				var original = DOMTokenList.prototype[method];
				DOMTokenList.prototype[method] = function (token) {
					var i,
					    len = arguments.length;
					for (i = 0; i < len; i++) {
						token = arguments[i];
						original.call(this, token);
					}
				};
			};
			createMethod('add');
			createMethod('remove');
		}
		testElement.classList.toggle("c3", false);
		if (testElement.classList.contains("c3")) {
			var _toggle = DOMTokenList.prototype.toggle;
			DOMTokenList.prototype.toggle = function (token, force) {
				var _contains_token = !this.contains(token);
				var _force = !force;
				if (1 in arguments && _contains_token === _force) {
					return force;
				} else {
					return _toggle.call(this, token);
				}
			};
		}
		if (!("replace" in document.createElement("_").classList)) {
			DOMTokenList.prototype.replace = function (token, replacement_token) {
				var tokens = this.toString().split(" "),
				    index = tokens.indexOf(token + "");
				if (~index) {
					tokens = tokens.slice(index);
					this.remove.apply(this, tokens);
					this.add(replacement_token);
					this.add.apply(this, tokens.slice(1));
				}
			};
		}
		testElement = null;
	})();
}
/* jshint bitwise: true */

/***/ }),

/***/ "../../node_modules/webpack/buildin/global.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "./polyfills/fetch-polyfill.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.Headers = Headers;
exports.Request = Request;
exports.Response = Response;
exports.fetch = fetch;
/* eslint-disable */
var global = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof global !== 'undefined' && global;

var support = {
    searchParams: 'URLSearchParams' in global,
    iterable: 'Symbol' in global && 'iterator' in Symbol,
    blob: 'FileReader' in global && 'Blob' in global && function () {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in global,
    arrayBuffer: 'ArrayBuffer' in global
};

function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}

if (support.arrayBuffer) {
    var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

    var isArrayBufferView = ArrayBuffer.isView || function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}

function normalizeName(name) {
    if (typeof name !== 'string') {
        name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
        throw new TypeError('Invalid character in header field name');
    }
    return name.toLowerCase();
}

function normalizeValue(value) {
    if (typeof value !== 'string') {
        value = String(value);
    }
    return value;
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
    var iterator = {
        next: function next() {
            var value = items.shift();
            return { done: value === undefined, value: value };
        }
    };

    if (support.iterable) {
        iterator[Symbol.iterator] = function () {
            return iterator;
        };
    }

    return iterator;
}

function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
        headers.forEach(function (value, name) {
            this.append(name, value);
        }, this);
    } else if (Array.isArray(headers)) {
        headers.forEach(function (header) {
            this.append(header[0], header[1]);
        }, this);
    } else if (headers) {
        Object.getOwnPropertyNames(headers).forEach(function (name) {
            this.append(name, headers[name]);
        }, this);
    }
}

Headers.prototype.append = function (name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};

Headers.prototype.delete = function (name) {
    delete this.map[normalizeName(name)];
};

Headers.prototype.get = function (name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};

Headers.prototype.has = function (name) {
    return this.map.hasOwnProperty(normalizeName(name));
};

Headers.prototype.set = function (name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
};

Headers.prototype.forEach = function (callback, thisArg) {
    for (var name in this.map) {
        if (this.map.hasOwnProperty(name)) {
            callback.call(thisArg, this.map[name], name, this);
        }
    }
};

Headers.prototype.keys = function () {
    var items = [];
    this.forEach(function (value, name) {
        items.push(name);
    });
    return iteratorFor(items);
};

Headers.prototype.values = function () {
    var items = [];
    this.forEach(function (value) {
        items.push(value);
    });
    return iteratorFor(items);
};

Headers.prototype.entries = function () {
    var items = [];
    this.forEach(function (value, name) {
        items.push([name, value]);
    });
    return iteratorFor(items);
};

if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
}

function consumed(body) {
    if (body.bodyUsed) {
        return Promise.reject(new TypeError('Already read'));
    }
    body.bodyUsed = true;
}

function fileReaderReady(reader) {
    return new Promise(function (resolve, reject) {
        reader.onload = function () {
            resolve(reader.result);
        };
        reader.onerror = function () {
            reject(reader.error);
        };
    });
}

function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}

function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
}

function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
        chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('');
}

function bufferClone(buf) {
    if (buf.slice) {
        return buf.slice(0);
    } else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}

function Body() {
    this.bodyUsed = false;

    this._initBody = function (body) {
        /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
        */
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._bodyText = '';
        } else if (typeof body === 'string') {
            this._bodyText = body;
        } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
            this._bodyBlob = body;
        } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
            this._bodyFormData = body;
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
            this._bodyText = body.toString();
        } else if (support.arrayBuffer && support.blob && isDataView(body)) {
            this._bodyArrayBuffer = bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([this._bodyArrayBuffer]);
        } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
            this._bodyArrayBuffer = bufferClone(body);
        } else {
            this._bodyText = body = Object.prototype.toString.call(body);
        }

        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') {
                this.headers.set('content-type', 'text/plain;charset=UTF-8');
            } else if (this._bodyBlob && this._bodyBlob.type) {
                this.headers.set('content-type', this._bodyBlob.type);
            } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
        }
    };

    if (support.blob) {
        this.blob = function () {
            var rejected = consumed(this);
            if (rejected) {
                return rejected;
            }

            if (this._bodyBlob) {
                return Promise.resolve(this._bodyBlob);
            } else if (this._bodyArrayBuffer) {
                return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            } else if (this._bodyFormData) {
                throw new Error('could not read FormData body as blob');
            } else {
                return Promise.resolve(new Blob([this._bodyText]));
            }
        };

        this.arrayBuffer = function () {
            if (this._bodyArrayBuffer) {
                var isConsumed = consumed(this);
                if (isConsumed) {
                    return isConsumed;
                }
                if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
                    return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                } else {
                    return Promise.resolve(this._bodyArrayBuffer);
                }
            } else {
                return this.blob().then(readBlobAsArrayBuffer);
            }
        };
    }

    this.text = function () {
        var rejected = consumed(this);
        if (rejected) {
            return rejected;
        }

        if (this._bodyBlob) {
            return readBlobAsText(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
            return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
        } else if (this._bodyFormData) {
            throw new Error('could not read FormData body as text');
        } else {
            return Promise.resolve(this._bodyText);
        }
    };

    if (support.formData) {
        this.formData = function () {
            return this.text().then(decode);
        };
    }

    this.json = function () {
        return this.text().then(JSON.parse);
    };

    return this;
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
}

function Request(input, options) {
    if (!(this instanceof Request)) {
        throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    }

    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
        if (input.bodyUsed) {
            throw new TypeError('Already read');
        }
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) {
            this.headers = new Headers(input.headers);
        }
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else {
        this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
        this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
        throw new TypeError('Body not allowed for GET or HEAD requests');
    }
    this._initBody(body);

    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) {
                // If it already exists then set the value with the current time
                this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            } else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}

Request.prototype.clone = function () {
    return new Request(this, { body: this._bodyInit });
};

function decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function (bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}

function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function (header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function (line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            headers.append(key, value);
        }
    });
    return headers;
}

Body.call(Request.prototype);

function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
        throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    }
    if (!options) {
        options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : '';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}

Body.call(Response.prototype);

Response.prototype.clone = function () {
    return new Response(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new Headers(this.headers),
        url: this.url
    });
};

Response.error = function () {
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response;
};

var redirectStatuses = [301, 302, 303, 307, 308];

Response.redirect = function (url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
        throw new RangeError('Invalid status code');
    }

    return new Response(null, { status: status, headers: { location: url } });
};

var DOMException = exports.DOMException = global.DOMException;
try {
    new DOMException();
} catch (err) {
    exports.DOMException = DOMException = function DOMException(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    DOMException.prototype = Object.create(Error.prototype);
    DOMException.prototype.constructor = DOMException;
}

function fetch(input, init) {
    return new Promise(function (resolve, reject) {
        var request = new Request(input, init);

        if (request.signal && request.signal.aborted) {
            return reject(new DOMException('Aborted', 'AbortError'));
        }

        var xhr = new XMLHttpRequest();

        function abortXhr() {
            xhr.abort();
        }

        xhr.onload = function () {
            var options = {
                status: xhr.status,
                statusText: xhr.statusText,
                headers: parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function () {
                resolve(new Response(body, options));
            }, 0);
        };

        xhr.onerror = function () {
            setTimeout(function () {
                reject(new TypeError('Network request failed'));
            }, 0);
        };

        xhr.ontimeout = function () {
            setTimeout(function () {
                reject(new TypeError('Network request failed'));
            }, 0);
        };

        xhr.onabort = function () {
            setTimeout(function () {
                reject(new DOMException('Aborted', 'AbortError'));
            }, 0);
        };

        function fixUrl(url) {
            try {
                return url === '' && global.location.href ? global.location.href : url;
            } catch (e) {
                return url;
            }
        }

        xhr.open(request.method, fixUrl(request.url), true);

        if (request.credentials === 'include') {
            xhr.withCredentials = true;
        } else if (request.credentials === 'omit') {
            xhr.withCredentials = false;
        }

        if ('responseType' in xhr) {
            if (support.blob) {
                xhr.responseType = 'blob';
            } else if (support.arrayBuffer && request.headers.get('Content-Type') && request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1) {
                xhr.responseType = 'arraybuffer';
            }
        }

        if (init && _typeof(init.headers) === 'object' && !(init.headers instanceof Headers)) {
            Object.getOwnPropertyNames(init.headers).forEach(function (name) {
                xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
            });
        } else {
            request.headers.forEach(function (value, name) {
                xhr.setRequestHeader(name, value);
            });
        }

        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);

            xhr.onreadystatechange = function () {
                // DONE (success or failure)
                if (xhr.readyState === 4) {
                    request.signal.removeEventListener('abort', abortXhr);
                }
            };
        }

        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}

fetch.polyfill = true;

if (!global.fetch) {
    global.fetch = fetch;
}
if (!global.Headers) {
    global.Headers = Headers;
}
if (!global.Request) {
    global.Request = Request;
}
if (!global.Response) {
    global.Response = Response;
}

/***/ }),

/***/ "./polyfills/svg-polyfill.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (SVGElement.prototype.getElementsByClassName === undefined) {
    SVGElement.prototype.getElementsByClassName = function (className) {
        return this.querySelectorAll('.' + className);
    };
}

/***/ }),

/***/ "./src/baseClass/base.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var REPLACE_PLACEHOLDER = /\[([\w\.-]+)]/g;
var PLACEHOLDER = /\[([\w\.-]+)]/g;
var STATE_UNDEFINED = 'wf-state-undefined';
var STATE_RESET = 'wf-state-reset';

var replaceAttr = function replaceAttr(attr) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        get = _ref.get;

    return attr.replace(REPLACE_PLACEHOLDER, function (fullString) {
        fullString = fullString.slice(1, -1);
        var fullStringArray = fullString.split('.');
        var valueArray = fullStringArray.slice(1, fullStringArray.length);
        var stateValue = get(window.wafer.base.state, valueArray);

        return stateValue || (stateValue === false ? false : STATE_UNDEFINED);
    });
};
var whiteListedEvents = new Map([['focusin', {
    passive: false
}], ['focusout', {
    passive: false
}], ['keydown', {
    passive: false
}], ['keyup', {
    passive: false
}], ['focusin', {
    passive: false
}], ['mousedown', {
    passive: false
}], ['mouseup', {
    passive: true
}], ['mouseleave', {
    passive: false
}], ['mouseover', {
    passive: false
}], ['mousemove', {
    passive: true
}], ['mouseenter', {
    passive: true
}], ['touchstart', {
    passive: true
}], ['touchend', {
    passive: true
}], ['touchmove', {
    passive: false
}], ['drag', {
    passive: false
}], ['dragenter', {
    passive: false
}], ['dragleave', {
    passive: false
}], ['dragover', {
    passive: false
}], ['dragstart', {
    passive: false
}], ['dragend', {
    passive: false
}], ['drop', {
    passive: false
}]]);

/**
 * WaferBase is base class which handles following:
 * - adding state observers
 */

var WaferBaseClass = function () {
    /**
     * class constructor
     * @param {object} elem element
     * @param {string} config.selector className to act on
     * @param {string} props.STATE_ATTRS state attributes
     * @param {string} props.DEFAULT_STATE_KEY_TO_UPDATE state
     * @return {void}
     */
    function WaferBaseClass(elem) {
        var _this = this;

        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            selector = _ref3.selector;

        var _ref2 = arguments[2];
        var STATE_ATTRS = _ref2.STATE_ATTRS,
            _ref2$DEFAULT_STATE_K = _ref2.DEFAULT_STATE_KEY_TO_UPDATE,
            DEFAULT_STATE_KEY_TO_UPDATE = _ref2$DEFAULT_STATE_K === undefined ? '' : _ref2$DEFAULT_STATE_K;

        _classCallCheck(this, WaferBaseClass);

        this._util = {
            elem: elem,
            selector: selector
        };
        var _window$wafer = window.wafer,
            constants = _window$wafer.constants,
            utils = _window$wafer.utils;
        var _constants$ATTR_PREFI = constants.ATTR_PREFIX,
            ATTR_PREFIX = _constants$ATTR_PREFI === undefined ? 'data-wf-' : _constants$ATTR_PREFI;

        var waferBase = window.wafer.base;
        var stateDidUpdate = this.stateDidUpdate && this.stateDidUpdate.bind(this);

        var _split = (elem.getAttribute(ATTR_PREFIX + 'on') || '').split(':'),
            _split2 = _slicedToArray(_split, 3),
            _split2$ = _split2[0],
            trigger = _split2$ === undefined ? 'complete' : _split2$,
            _split2$2 = _split2[1],
            action = _split2$2 === undefined ? 'setState' : _split2$2,
            _split2$3 = _split2[2],
            key = _split2$3 === undefined ? DEFAULT_STATE_KEY_TO_UPDATE : _split2$3;

        trigger = trigger || 'complete';
        if (key && trigger === 'complete') {
            if (action === 'setState') {
                this._util.shouldUpdateState = true;
            } else if (action === 'toggleState') {
                this._util.shouldToggleState = true;
            }
            this._util.stateKeysToUpdate = key.split('.');
        }
        stateDidUpdate && STATE_ATTRS.forEach(function (stateAttr) {
            var _stateAttr = elem.getAttribute(ATTR_PREFIX + '[' + stateAttr + ']') || elem.getAttribute(ATTR_PREFIX + 'state-' + stateAttr);
            var originalAttr = elem.getAttribute('' + ATTR_PREFIX + stateAttr);

            // add state observers for state dependent attributes
            if (_stateAttr) {
                var placeHolders = void 0;
                while ((placeHolders = PLACEHOLDER.exec(_stateAttr)) !== null) {
                    // check if any placeholders are present within the attributes
                    var _placeHolder = placeHolders[1];

                    var _placeHolder$split = _placeHolder.split('.'),
                        _placeHolder$split2 = _toArray(_placeHolder$split),
                        _placeHolderType = _placeHolder$split2[0],
                        _placeHolderArray = _placeHolder$split2.slice(1);

                    if (_placeHolderType === 'state') {
                        (function () {
                            var self = _this;

                            var _placeHolderArray2 = _slicedToArray(_placeHolderArray, 1),
                                property = _placeHolderArray2[0];

                            var val = replaceAttr(_stateAttr, utils);

                            // update value using state only if its valid
                            if (!originalAttr && val.indexOf(STATE_UNDEFINED) === -1 && val.indexOf(STATE_RESET) === -1) {
                                _this._util[stateAttr] = val;
                            }
                            var observerFn = function observerFn() {
                                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                                    _ref4$force = _ref4.force,
                                    force = _ref4$force === undefined ? false : _ref4$force;

                                if (self._destroyed) {
                                    // lazy removal of observer
                                    waferBase.removeObserver.call(waferBase, property, observerFn);
                                    return;
                                }
                                var prevVal = self._util[stateAttr];

                                self._util[stateAttr] = replaceAttr(_stateAttr, utils);
                                // call stateDidUpdate only if state was updated properly
                                if (self._util[stateAttr].indexOf(STATE_UNDEFINED) === -1 && (
                                // don't update state if previous value is same as new value
                                // compare only flat structures
                                force || prevVal !== self._util[stateAttr])) {
                                    if (self._util[stateAttr].indexOf(STATE_RESET) === -1) {
                                        stateDidUpdate({
                                            stateAttr: stateAttr
                                        });
                                    } else {
                                        // empty the value
                                        self._util[stateAttr] = undefined;
                                    }
                                } else {
                                    // restore state back to previous val
                                    self._util[stateAttr] = prevVal;
                                }
                            };
                            // the reason we use timeout here is bec super method
                            // is called before constructor of main class and
                            // constructor of main class sets all props
                            // using timeout we hack around by delaying calling observerFn
                            // so that all util values are set
                            setTimeout(function () {
                                observerFn();
                            }, 0);
                            // adding observer only for top level
                            waferBase.addObserver(property, observerFn);
                        })();
                    }
                }
            }
        });
    }

    _createClass(WaferBaseClass, [{
        key: 'isReady',


        /**
         * check if wafer for current element / instance is ready
         * @return {boolean} true if it is ready and false if it is not ready of destroyed
         */
        value: function isReady() {
            if (!this._util || this._destroyed) {
                return false;
            }
            return true;
        }

        /**
         * Add all required event listeners
         * Note: This method needs to called from extended class.
         * @return {void}
         */

    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            this._addEventListenerToEvents(window.wafer.utils.bindEvent, 'bindEvent');
        }

        /**
         * Add all required event listeners
         * Note: This method needs to called from extended class.
         * @return {void}
         */

    }, {
        key: 'removeEventListeners',
        value: function removeEventListeners() {
            this._addEventListenerToEvents(window.wafer.utils.unbindEvent, 'unbindEvent');
        }

        /* Private methods */
        /**
         * apply event listener function to all events present in mapping defined in extending class
         * Only white listed events are bound
         * @param {function} eventFn binding function
         * @param {function} eventName event name
         * @return {void}
         */

    }, {
        key: '_addEventListenerToEvents',
        value: function _addEventListenerToEvents(eventFn, eventName) {
            var _this2 = this;

            var elem = this._util.elem;
            var events = this.constructor.events;

            var isBindEvent = eventName === 'bindEvent';

            if (events) {
                var _loop = function _loop(_eventName) {
                    if (events.hasOwnProperty(_eventName)) {
                        var _ret3 = function () {
                            if (!whiteListedEvents.has(_eventName)) {
                                return {
                                    v: 'continue'
                                };
                            }
                            var values = events[_eventName];
                            var eventConfig = whiteListedEvents.get(_eventName);

                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                var _loop2 = function _loop2() {
                                    var _step$value = _slicedToArray(_step.value, 2),
                                        valueClass = _step$value[0],
                                        valueFn = _step$value[1];

                                    var eventElem = void 0;

                                    if (valueClass === '_self') {
                                        eventElem = elem;
                                    } else {
                                        eventElem = [].concat(_toConsumableArray(elem.getElementsByClassName(valueClass)));
                                    }
                                    if (false) {
                                        if (!eventElem) {
                                            console.warn('%c' + eventFn.name + ' for ' + _this2.constructor.name + ' %cis called without events defined. Please avoid calling this method if event binding is not required', 'color:red', 'color:orange');
                                        }
                                    }
                                    if (eventElem && _this2[valueFn]) {
                                        // if eventFn is bind function, bind class function to proper scope
                                        if (isBindEvent) {
                                            _this2[valueFn] = _this2[valueFn].bind(_this2);
                                        }
                                        if (Array.isArray(eventElem)) {
                                            // bind event to each element if we have multiple of them for given wafer
                                            eventElem.forEach(function (elem) {
                                                eventFn.call(_this2, elem, _eventName, _this2[valueFn], eventConfig);
                                            });
                                        } else {
                                            eventFn.call(_this2, eventElem, _eventName, _this2[valueFn], eventConfig);
                                        }
                                    }
                                };

                                for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    _loop2();
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }();

                        if ((typeof _ret3 === 'undefined' ? 'undefined' : _typeof(_ret3)) === "object") return _ret3.v;
                    }
                };

                for (var _eventName in events) {
                    var _ret2 = _loop(_eventName);

                    if (_ret2 === 'continue') continue;
                }
            }
        }

        /* End of Private methods */
        // ------------------------------------------------------------

        /* Public methods */
        /**
         * Lifecycle method to be called once wafer is done with its respective job
         * - Handles updating state if wafer 'on' attribute is defined
         *     with 'trigger' as 'complete' and 'action' as setState
         * @param {object} err error object
         * @param {object} values wafer complete values
         * @return {void}
         */

    }, {
        key: 'didComplete',
        value: function didComplete(err, values) {
            var _util = this._util,
                shouldToggleState = _util.shouldToggleState,
                shouldUpdateState = _util.shouldUpdateState,
                stateKeysToUpdate = _util.stateKeysToUpdate;


            if (shouldUpdateState) {
                var finalValue = {};

                stateKeysToUpdate.reduce(function (all, current, index) {
                    all[current] = all[current] || {};
                    if (index === stateKeysToUpdate.length - 1) {
                        all[current] = values;
                    }
                    return all[current];
                }, finalValue);
                window.wafer.base.state = finalValue;
            } else if (shouldToggleState) {
                var _stateKeysToUpdate = _toArray(stateKeysToUpdate),
                    firstActionKey = _stateKeysToUpdate[0],
                    remainingActionKeys = _stateKeysToUpdate.slice(1);

                var remainingActionKeysLen = remainingActionKeys.length;

                if (remainingActionKeysLen) {
                    var newState = window.wafer.base.state[firstActionKey] || {};

                    remainingActionKeys.reduce(function (all, current, index) {
                        // toggle only the last value
                        if (index === remainingActionKeysLen - 1) {
                            all[current] = !all[current];
                        } else {
                            all[current] = all[current] || {};
                        }
                        return all[current];
                    }, newState);
                    window.wafer.state = _defineProperty({}, firstActionKey, newState);
                } else {
                    // toggle value if state keys length is 1
                    window.wafer.state = _defineProperty({}, firstActionKey, !window.wafer.base.state[firstActionKey]);
                }
            }
        }

        /**
         * handle destroy
         * @return {void}
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            var _util2 = this._util,
                elem = _util2.elem,
                selector = _util2.selector;


            window.wafer.utils.clearTimeoutForInstance(this);
            if (elem) {
                selector && elem.classList.remove(selector.replace('.', ''));
                elem.classList.add('wafer-destroyed'); // add class for debugging and testing purpose
            }
            this._util = {};
            this._state = {};
            this._destroyed = true;
        }

        /* End of Public methods */
        // ------------------------------------------------------------

    }, {
        key: 'lock',
        set: function set(val) {
            this._state = this._state || {};
            this._state.locked = val;
            if (val) {
                this.didLock && this.didLock();
            } else {
                this.didUnLock && this.didUnLock();
            }
        }
    }]);

    return WaferBaseClass;
}();

exports.default = WaferBaseClass;
module.exports = exports['default'];

/***/ }),

/***/ "./src/baseClass/baseController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * WaferBaseController is base controller class which handles following:
 * - binding events if event hash is available
 * - creating initial state
 * - creating options
 * - basic setup - responsible for building elementInstances map and binding events
 * - validate - responsible for handling controller validation
 */
var WaferBaseController = function () {
    /**
     * class constructor
     * @param {object} config.root=document root container
     * @param {string} config.selector className to act on
     * @param {object} config.props={} props to be passed to instance class
     * @param {string} config.WaferClass WaferClass for which instances should be created
     * @return {void}
     */
    function WaferBaseController() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            root = _ref.root,
            selector = _ref.selector,
            _ref$props = _ref.props,
            props = _ref$props === undefined ? {} : _ref$props,
            WaferClass = _ref.WaferClass;

        _classCallCheck(this, WaferBaseController);

        // create _state which will hold state
        this._state = {
            elementInstances: new Map(),
            mounted: false // controller is mounted only if it has atleast one instance with events attached
        };
        // create _options which will hold configs
        this._options = {
            props: props,
            root: root,
            selector: selector,
            WaferClass: WaferClass
        };
        if (WaferClass && WaferClass.events) {
            Object.keys(WaferClass.events).forEach(function (event) {
                WaferClass.events[event] = new Map(WaferClass.events[event]);
            });
        }
    }

    /* Public methods */

    /**
     * responsible for calling handleResize for each mounted instance
     * @return {void}
     */


    _createClass(WaferBaseController, [{
        key: 'handleResize',
        value: function handleResize() {
            var elementInstances = this._state.elementInstances;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {

                for (var _iterator = elementInstances.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref3 = _step.value;
                    var instance = _ref3.instance;
                    var handleResize = instance.handleResize;

                    var _ref4 = instance._state || {},
                        locked = _ref4.locked;

                    if (locked !== true) {
                        handleResize && handleResize.call(instance);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        /**
         * responsible for handling event
         * Method ensures calling _handleEvent for controllers
         * which are interested in events (declared event hash)
         * and have target equal to instance element
         * @param {string} event event type
         * @param {object} selectorNode selector DOM node
         * @param {object} e event object
         * @return {void}
         */

    }, {
        key: 'handleEvent',
        value: function handleEvent(event, selectorNode, e) {
            var WaferClass = this._options.WaferClass;
            var elementInstances = this._state.elementInstances;


            if (event === 'clickOutside') {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = elementInstances.values()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _ref6 = _step2.value;
                        var instance = _ref6.instance;

                        if (instance) {
                            var handleClickOutside = instance.handleClickOutside;


                            handleClickOutside && handleClickOutside.call(instance, e);
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return;
            }
            if (WaferClass && WaferClass.events) {
                var instance = elementInstances.get(selectorNode);

                instance && this._handleEvent(event, e, instance);
            }
        }

        /**
         * Responsible for invoking handleKeyDown for all wafer instances
         * Method ensures handleKeyDown is not called if wafer is locked
         * @param {object} e event object
         * @return {void}
         */

    }, {
        key: 'handleKeyboardDown',
        value: function handleKeyboardDown(e) {
            var elementInstances = this._state.elementInstances;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {

                for (var _iterator3 = elementInstances.values()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _ref8 = _step3.value;
                    var instance = _ref8.instance;

                    if (instance) {
                        var handleKeyboardDown = instance.handleKeyboardDown;

                        var _ref9 = instance._state || {},
                            locked = _ref9.locked;

                        if (locked !== true) {
                            handleKeyboardDown && handleKeyboardDown.call(instance, e);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }

        /**
         * responsible for following locking wafers for given element
         * @param {object} [elem] - element to lock
         * @param {boolean} shouldLock=true should lock
         * @return {void}
         */

    }, {
        key: 'lock',
        value: function lock(elem) {
            var shouldLock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var elementInstances = this._state.elementInstances;
            var _options = this._options,
                root = _options.root,
                selector = _options.selector,
                successClass = _options.successClass;

            var elems = [];

            if (selector) {
                elems = Array.prototype.slice.call((elem || root).getElementsByClassName(selector.replace('.', ''))).filter(function (node) {
                    return !node.classList.contains(successClass);
                });
            }
            var elemsLength = elems.length;

            if (elemsLength) {
                elems.forEach(function (node) {
                    if (elementInstances.has(node)) {
                        var _elementInstances$get = elementInstances.get(node),
                            instance = _elementInstances$get.instance;

                        if (instance) {
                            instance.lock = shouldLock;
                        } else {
                            node.setAttribute('data-wf-lock', shouldLock ? '1' : '0');
                        }
                    }
                });
            }
        }

        /**
         * responsible for following
         * 1) update list of stored elements by getting all the children
         * having selector class for the root container.
         * 2) add scroll listener to containers if containerClass is provided
         * 3) on recalculating elements list, check if any of the element
         * is intersecting with cached view-port
         * @param {object} [elem] - element to sync
         * @return {void}
         */

    }, {
        key: 'sync',
        value: function sync(elem) {
            var _this = this;

            var elementInstances = this._state.elementInstances;
            var _options2 = this._options,
                props = _options2.props,
                root = _options2.root,
                selector = _options2.selector,
                successClass = _options2.successClass,
                WaferClass = _options2.WaferClass;

            var elems = [];

            if (selector) {
                elems = Array.prototype.slice.call((elem || root).getElementsByClassName(selector.replace('.', ''))).filter(function (node) {
                    return !node.classList.contains(successClass);
                });
            }
            var elemsLength = elems.length;

            if (elemsLength) {
                var willSync = this.willSync;

                willSync && willSync.call(this, elem);
                elems.forEach(function (node) {
                    // don't add node if it already exists
                    if (!elementInstances.has(node)) {
                        var instance = void 0;

                        if (WaferClass) {
                            instance = new WaferClass(node, _extends({}, props, {
                                selector: selector
                            }));
                            var _destroy = instance.destroy;
                            var self = _this;

                            instance.destroy = function () {
                                var _ref10 = self._state || {},
                                    activeElem = _ref10.activeElem;

                                // Wafers which hold active state like video and caas don't reset activeElem if destroyed element is activeElem on their own
                                // Adding that logic here helps nullify active element at a generic location
                                // This logic assumes controller is using this._state.activeElem to hold activeElem. If any controller deviates, this logic wont work


                                if (activeElem === node) {
                                    self._state.activeElem = null;
                                }
                                elementInstances.delete(node);

                                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                                    args[_key] = arguments[_key];
                                }

                                _destroy.apply(instance, args);
                            };
                        }
                        elementInstances.set(node, {
                            instance: instance
                        });
                    }
                });
            }
            this.validate();
            if (elemsLength) {
                var didSync = this.didSync;

                didSync && didSync.call(this, elem);
            }
        }

        /**
         * handle trigger wafer for given element
         * @param {object} [elem] - element to sync
         * @return {void}
         */

    }, {
        key: 'handleTrigger',
        value: function handleTrigger(elem) {
            var _options3 = this._options,
                selector = _options3.selector,
                successClass = _options3.successClass;


            if (elem.classList.contains(selector.replace('.', '')) && !elem.classList.contains(successClass)) {
                var willTrigger = this.willTrigger;
                var trigger = this.trigger;
                var didTrigger = this.didTrigger;

                willTrigger && willTrigger.call(this, elem);
                trigger && this.trigger(elem);
                didTrigger && didTrigger.call(this, elem);
            }
        }

        /**
         * this method handles validation of the controller. Using lifecycle
         * methods of validate will help extending class add its business logic (ex viewport detection)
         * If extending controller needs some validation at beginning, call this method as part of constructor
         * @param {object} params Additional params
         * @param {string} params.source callee source for validate
         * @param {string} params.scrollDirection scroll direction of page. 1 for down, 0 for up
         * @return {void}
         */

    }, {
        key: 'validate',
        value: function validate() {
            var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                source = _ref11.source,
                scrollDirection = _ref11.scrollDirection;

            var elementInstances = this._state.elementInstances;


            if (elementInstances.size === 0) {
                this.destroy();
                return;
            }
            var elemsToValidate = [];

            // pass filtered elementInstances
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = elementInstances.entries()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var _step4$value = _slicedToArray(_step4.value, 2),
                        elem = _step4$value[0],
                        value = _step4$value[1];

                    var instance = value.instance;

                    if (!instance) {
                        elemsToValidate.push(elem);
                        continue;
                    }

                    var _ref12 = instance._state || {},
                        locked = _ref12.locked;

                    if (locked !== true) {
                        elemsToValidate.push(elem);
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            if (elemsToValidate.length) {
                var willValidate = this.willValidate;
                willValidate && willValidate.call(this, elemsToValidate, {
                    source: source,
                    scrollDirection: scrollDirection
                });
            }
            this._state.mounted = true;
        }

        /**
         * responsible for destroying instances and events created by controller.
         * If elem is provided, only elem instance are destroyed.
         * If not, everything created by controller is destroyed
         * @param {object} [elem] - element which needs to be destroyed
         * @return {void}
         */

    }, {
        key: 'destroy',
        value: function destroy(elem) {
            var willDestroy = this.willDestroy;
            var didDestroy = this.didDestroy;

            if (elem) {
                var elementInstances = this._state.elementInstances;


                if (elementInstances.has(elem)) {
                    willDestroy && willDestroy.call(this, elem);

                    var _elementInstances$get2 = elementInstances.get(elem),
                        instance = _elementInstances$get2.instance;

                    instance && instance.destroy();
                    elementInstances.delete(elem);
                    didDestroy && didDestroy.call(this, elem);
                }
                return;
            }

            willDestroy && willDestroy.call(this);
            this._destroyAll();
            didDestroy && didDestroy.call(this);
        }

        /* End of Public methods */

        // ------------------------------------------------------------

        /* Private methods */

        /**
         * responsible for following
         * - unbind controller created events
         * - reset state
         * - destroy all instances created
         * @return {void}
         */

    }, {
        key: '_destroyAll',
        value: function _destroyAll() {
            var state = this._state;

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = state.elementInstances.values()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var _ref14 = _step5.value;
                    var instance = _ref14.instance;

                    instance && instance.destroy();
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            state.elementInstances.clear();
            state.mounted = false;
        }

        /**
         * handleClick for each container. DOM elements within the container use delegation pattern
         * If click target contains any of the class name
         * mapped in event hash, respective instance mapped method is called
         * @param {string} type event type
         * @param {object} e event object
         * @param {object} instanceValue instance for given event
         * @return {void}
         */

    }, {
        key: '_handleEvent',
        value: function _handleEvent(type, e, instanceValue) {
            var WaferClass = this._options.WaferClass;

            var eventType = WaferClass.events[type];

            if (eventType) {
                var _target = e.target;
                while (_target) {
                    if (_target.className) {
                        var hasHandler = void 0;
                        var _iteratorNormalCompletion6 = true;
                        var _didIteratorError6 = false;
                        var _iteratorError6 = undefined;

                        try {
                            for (var _iterator6 = eventType.entries()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                var _step6$value = _slicedToArray(_step6.value, 2),
                                    className = _step6$value[0],
                                    fn = _step6$value[1];

                                if (_target.classList.contains(className)) {
                                    var _instance = instanceValue.instance;
                                    var _fn = _instance && _instance[fn];

                                    // eventTarget is delegate target.
                                    // Added eventTarget as separate key
                                    // due to read-only property of target.
                                    // We dont want to clone whole of
                                    // event to only replace target
                                    e.eventTarget = _target;
                                    _fn && _fn.call(_instance, e);
                                    hasHandler = true;
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }
                            } finally {
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }

                        if (hasHandler) {
                            _target = null;
                        } else {
                            _target = _target.parentElement;
                        }
                    } else {
                        _target = _target.parentElement;
                    }
                }
            }
        }
    }]);

    return WaferBaseController;
}();

exports.default = WaferBaseController;
module.exports = exports['default'];

/***/ }),

/***/ "./src/baseClass/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WaferBaseController = exports.WaferBaseClass = undefined;

var _base;

function _load_base() {
  return _base = _interopRequireDefault(__webpack_require__("./src/baseClass/base.js"));
}

var _baseController;

function _load_baseController() {
  return _baseController = _interopRequireDefault(__webpack_require__("./src/baseClass/baseController.js"));
}

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.WaferBaseClass = (_base || _load_base()).default;
exports.WaferBaseController = (_baseController || _load_baseController()).default;

/***/ }),

/***/ "./src/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Object.freeze({
    ATTR_PREFIX: 'data-wf-'
});
module.exports = exports['default'];

/***/ }),

/***/ "./src/controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._ready = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ee;

function _load_ee() {
    return _ee = _interopRequireDefault(__webpack_require__("./src/utils/ee.js"));
}

var _indexDB;

function _load_indexDB() {
    return _indexDB = _interopRequireDefault(__webpack_require__("./src/utils/indexDB.js"));
}

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CHECK_WAFER_REGEX = /(wf-[a-z-]+)/;
var RESIZE_DELAY = 10; // delay for throttling window.resize
var SAVE_VIEWPORT_OFFSET_DELAY = 50; // delay for throttling saveViewportOffset
var SCROLL_DELAY = 10; // delay for throttling window.scroll
var SYNC_DELAY = 0; // delay for throttling sync
var DEFAULT_SCRIPT_TYPE = 'text/javascript';
var READY_FNS_EXECUTED = false;

/* Private helper functions
 ************************************/

/**
 * @private
 * Call function once document is ready.
 * @param {function} fn function to be called once document is ready
 * @returns {void}
 */
var _ready = exports._ready = function _ready(fn) {
    if (!(!document.attachEvent || typeof document.attachEvent === 'undefined')) {
        var readyCallbackExecuted = false;
        document.attachEvent('onreadystatechange', function () {
            var _document = document,
                readyState = _document.readyState;

            if (readyState === 'interactive') {
                readyCallbackExecuted = true;
                setTimeout(fn, 0);
            } else if (readyState === 'complete') {
                !readyCallbackExecuted && setTimeout(fn, 0);
                readyCallbackExecuted = true;
            }
        });
    } else {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn, {
                capture: false,
                passive: true
            });
        } else {
            setTimeout(fn, 0);
        }
    }
};

/* End of Private helper functions
 ************************************/

/** Class representing Wafer Base controller which holds and communicates with every Wafer controller */

var WaferController = function () {
    /**
     * class constructor handling following:
     * - global event binding
     */
    function WaferController() {
        var _this = this;

        _classCallCheck(this, WaferController);

        this._viewport = {
            top: 0,
            left: 0
        };
        this._state = {
            colorSchemaEventAdded: false
        };
        this._assetLoadedMapping = new Map();
        this._isPageVisible = true;
        this._observerMapping = {};
        this._isOldCacheCleared = false;
        this._colorSchemaOverrideTheme = null;
        this._saveViewportOffset();
        this._updateState();
        this._initHostConfig();
        this._props = {
            darkmodeSupportSystemDefault: document.documentElement.getAttribute('data-color-theme-enabled') === 'true',
            head: document.getElementsByTagName('head')[0]
        };
        this._handleVisibilityChange = this._handleVisibilityChange.bind(this);
        _ready(function () {
            if (!window.wafer || !window.wafer.utils) {
                return;
            }
            _this._initDB(function () {
                if (!READY_FNS_EXECUTED) {
                    // __ signifies it was added directly from entry
                    _this.__executeAllRegisteredReadyFns();
                    READY_FNS_EXECUTED = true;
                }
            });
            _this._setup();
            setTimeout(function () {
                if (!READY_FNS_EXECUTED) {
                    // __ signifies it was added directly from entry
                    _this.__executeAllRegisteredReadyFns();
                    READY_FNS_EXECUTED = true;
                }
            }, 20);
        });
    }

    /**
     * add observer for property
     * @param {string} property name
     * @param {function} observer observer function
     * @returns {void}
     */


    _createClass(WaferController, [{
        key: 'addObserver',
        value: function addObserver(property) {
            var observer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

            if (!this._observerMapping[property]) {
                this._observerMapping[property] = [];
            }
            this._observerMapping[property].push(observer);
        }

        /**
         * remove observer for property
         * @param {string} property name
         * @param {function} observer observer function
         * @returns {void}
         */

    }, {
        key: 'removeObserver',
        value: function removeObserver(property) {
            var observer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

            if (this._observerMapping[property]) {
                var index = this._observerMapping[property].indexOf(observer);

                this._observerMapping[property].splice(index, 1);
            }
        }

        /**
         * Sync all wafers
         * @param {object} [elem] dom element
         * @returns {void}
         */

    }, {
        key: 'sync',
        value: function sync() {
            var _this2 = this;

            var elem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (!this._sync) {
                // wafer is not yet ready, retry after it is ready
                window.wafer.ready(function () {
                    _this2.sync(elem);
                });
                return;
            }
            this._sync(elem);
        }

        /**
         * Sync all wafers and force update state
         * @param {object} [elem] dom element
         * @returns {void}
         */

    }, {
        key: 'syncWithStateUpdate',
        value: function syncWithStateUpdate() {
            var _this3 = this;

            var elem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (!this._sync) {
                // wafer is not yet ready, retry after it is ready
                window.wafer.ready(function () {
                    _this3.syncWithStateUpdate(elem);
                });
                return;
            }
            this._sync(elem);
            // force execute all observer functions
            for (var key in this._observerMapping) {
                if (this._observerMapping.hasOwnProperty(key)) {
                    this._observerMapping[key].forEach(function (fn) {
                        fn({ force: true });
                    });
                }
            }
        }

        /**
         * pause active video
         * @param {string} src source event name
         * @returns {void}
         */

    }, {
        key: 'pauseVideo',
        value: function pauseVideo(src) {
            if (!src) {
                this._handleVideoPlayPause('pauseAll');
                return;
            }
            this._handleVideoPlayPause('pause', src);
        }

        /**
         * resume paused active video
         * @param {string} src source event name
         * @returns {void}
         */

    }, {
        key: 'resumeVideo',
        value: function resumeVideo(src) {
            this._handleVideoPlayPause('resume', src);
        }

        /**
         * close open lightbox
         * @param {object} params passed for close
         * @param {boolean} config.scrollRestore=true boolean to enable / disable scroll restoration
         * @returns {void}
         */

    }, {
        key: 'closeLightbox',
        value: function closeLightbox() {
            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref$scrollRestore = _ref.scrollRestore,
                scrollRestore = _ref$scrollRestore === undefined ? true : _ref$scrollRestore;

            var getWaferForType = window.wafer.utils.getWaferForType;

            var lightboxController = getWaferForType('wafer-lightbox');

            if (!lightboxController) {
                return;
            }
            lightboxController._close({ scrollRestore: scrollRestore });
        }

        /**
         * locks wafers for mutation and activation
         * @param {object} [elem] dom element
         * @returns {void}
         */

    }, {
        key: 'lock',
        value: function lock() {
            var elem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this._wafers.forEach(function (wafer) {
                wafer.lock && wafer.lock(elem);
            });
        }

        /**
         * unlocks wafers for mutation and activation
         * @param {object} [elem] dom element
         * @returns {void}
         */

    }, {
        key: 'unlock',
        value: function unlock() {
            var elem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this._wafers.forEach(function (wafer) {
                wafer.lock && wafer.lock(elem, false);
            });
        }

        /**
         * Sync UI for all wafers
         * @param {object} [elem] dom element
         * @returns {void}
         */

    }, {
        key: 'syncUI',
        value: function syncUI() {
            var elem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this._wafers.forEach(function (wafer) {
                wafer._state && wafer._state.mounted && wafer.handleResize && wafer.handleResize(elem);
            });
        }

        /**
         * load all JS assets after markup is mounted
         * @param {object} assets assets object
         */

    }, {
        key: 'syncAssets',
        value: function syncAssets() {
            var _this4 = this;

            var assets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _assets$js = assets.js,
                js = _assets$js === undefined ? [] : _assets$js,
                blob = assets.blob;

            var waferJs = [];
            var customJs = [];
            var wafers = window.wafer.wafers;

            var blobJs = [];

            js.forEach(function (asset) {
                var value = asset.value;

                // don't load wafer-core and wafers already present on page

                if (value.indexOf('wf-') !== -1) {
                    var _value$match = value.match(CHECK_WAFER_REGEX),
                        _value$match2 = _slicedToArray(_value$match, 1),
                        waferName = _value$match2[0];

                    waferName = waferName.slice(0, -1).replace('wf-', 'wafer-');
                    if (waferName !== 'wafer-core' && !wafers[waferName]) {
                        waferJs.push(asset);
                    }
                } else {
                    customJs.push(asset);
                }
            });
            // handle blob
            if (Array.isArray(blob) && blob.length) {
                var tempNode = document.createElement('div');
                var convertNodeListToArray = window.wafer.utils.convertNodeListToArray;
                var head = this._props.head;


                blob.forEach(function (blobStr) {
                    if (Object(blobStr) === blobStr) {
                        tempNode.innerHTML += blobStr.value || '';
                    }
                });
                blobJs = convertNodeListToArray(tempNode.querySelectorAll('script'));
                // handle style tags
                convertNodeListToArray(tempNode.getElementsByTagName('style')).forEach(function (styleNode) {
                    head.appendChild(styleNode);
                });
            }
            var customJSPromise = void 0;

            if (customJs.length) {
                // add all custom script first and then add  wafer
                customJSPromise = Promise.all(customJs.map(function (asset) {
                    var value = asset.value;
                    if (asset.cdnOrigin === '') {
                        value = location.origin + value;
                    }
                    return _this4._loadAsset(value, 'js');
                })).catch(function () {
                    // do nothing
                });
            } else {
                customJSPromise = Promise.resolve();
            }
            customJSPromise.then(function () {
                var loadScriptAsync = window.wafer.utils.loadScriptAsync;

                // handle blob script tags
                // execute blob scripts only after custom JS is added on page

                blobJs.forEach(function (scriptNode) {
                    var type = scriptNode.getAttribute('type') || DEFAULT_SCRIPT_TYPE;
                    var text = scriptNode.innerText;

                    if (text && type === DEFAULT_SCRIPT_TYPE) {
                        loadScriptAsync({
                            type: type,
                            text: text
                        });
                    }
                });
            });
            waferJs.map(function (asset) {
                var value = asset.value;
                if (asset.cdnOrigin === '') {
                    value = location.origin + value;
                }
                return _this4._loadAsset(value, 'js');
            });
        }

        /**
         * Trigger all wafers for given element
         * @param {object} [elem] dom element
         * @returns {void}
         */

    }, {
        key: 'trigger',
        value: function trigger() {
            var elem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (elem) {
                elem.classList.add('wf-trigger-activated');
            }
            this._wafers.forEach(function (wafer) {
                wafer._state && wafer._state.mounted && wafer.handleTrigger && wafer.handleTrigger(elem);
            });
        }

        /**
         * prefetch wafers for given element
         * for wafer controller to enable prefetch, allowPrefetch should
         * set to true in config prototype
         * @param {object} [elem] dom element
         * @returns {void}
         */

    }, {
        key: 'prefetch',
        value: function prefetch(elem) {
            var pageContext = window.wafer.base.pageContext;

            // don't prefetch for external bot requests

            if (pageContext.bot === '1' && pageContext.ynet !== '1') {
                return;
            }
            this._wafers.forEach(function (wafer) {
                var configs = wafer && wafer.configs;

                if (configs) {
                    var allowPrefetch = configs.allowPrefetch,
                        selector = configs.selector;


                    if (allowPrefetch) {
                        selector && Array.prototype.slice.call(elem.getElementsByClassName(selector.replace('.', ''))).forEach(function (elem) {
                            return wafer.loadElement(elem);
                        });
                    }
                }
            });
            // handle native lazy loading elements as those elements are destroyed by wafer once
            // attribute is added
            var _window$wafer = window.wafer,
                features = _window$wafer.features,
                utils = _window$wafer.utils;
            var getElementsByAttrValues = utils.getElementsByAttrValues;
            var nativeLazyLoadingSupported = features.nativeLazyLoadingSupported;


            if (nativeLazyLoadingSupported) {
                var _getElementsByAttrVal = getElementsByAttrValues('loading', ['lazy'], elem),
                    lazy = _getElementsByAttrVal.lazy;

                lazy.forEach(function (elem) {
                    elem.setAttribute('loading', 'eager');
                });
            }
        }

        /**
         * Emit error event
         * @param {object} elem dom element throwing error
         * @param {object} params.meta error params specific to wafer
         * @param {string} params.name wafer name
         * @param {object} params.stack error stack
         * @returns {void}
         */

    }, {
        key: 'emitError',
        value: function emitError() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                elem = _ref2.elem,
                meta = _ref2.meta,
                name = _ref2.name,
                stack = _ref2.stack;

            this._emit({
                elem: elem,
                meta: meta,
                name: name,
                stack: stack
            });
        }

        /**
         * Emit log event
         * @param {object} elem dom element throwing error
         * @param {object} params.meta error params specific to wafer
         * @param {string} params.name wafer name
         * @returns {void}
         */

    }, {
        key: 'emitLog',
        value: function emitLog() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                elem = _ref3.elem,
                meta = _ref3.meta,
                name = _ref3.name;

            this._emit({
                elem: elem,
                meta: meta,
                name: name
            }, 'log');
        }

        /**
         * Emit wafer event
         * @param {string} name Wafer name
         * @param {object} params.elem dom element throwing error
         * @param {object} params.meta error params specific to wafer
         * @returns {void}
         */

    }, {
        key: 'emitWaferEvent',
        value: function emitWaferEvent(name) {
            var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                elem = _ref4.elem,
                meta = _ref4.meta;

            this._emit({
                elem: elem,
                meta: meta
            }, name);
        }

        /**
         * Destroy all wafers on page for given element
         * @param {object} [elem] dom element
         * @param {boolean} options.destroySelf=true if true destroys wafer bound to elem, if false only destroys children
         * @returns {void}
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            var elem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                _ref5$destroySelf = _ref5.destroySelf,
                destroySelf = _ref5$destroySelf === undefined ? true : _ref5$destroySelf;

            if (!elem) {
                return;
            }
            // destroy all children wafers of element
            var children = elem.children;
            // checking children as IE does not have children for SVG
            if (children) {
                for (var i = children.length; i--;) {
                    this.destroy(children[i]);
                }
            }
            destroySelf && this._wafers.forEach(function (wafer) {
                wafer.destroy && wafer.destroy(elem);
            });
        }

        /**
         * clear old cache
         * @param {number} config.timeDiffToDelete=1800000 set timeout (default is 30 minutes)
         * @returns {void}
         */

    }, {
        key: 'clearOldCache',
        value: function clearOldCache() {
            var _this5 = this;

            var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref6$timeDiffToDelet = _ref6.timeDiffToDelete,
                timeDiffToDelete = _ref6$timeDiffToDelet === undefined ? 1800000 : _ref6$timeDiffToDelet;

            // this is ensure we don't call this method multiple times
            if (this._isOldCacheCleared) {
                return;
            }
            this._isOldCacheCleared = true;
            window.wafer.db && window.wafer.db.clean('fetch', {
                timeDiffToDelete: timeDiffToDelete
            }).catch(function (e) {
                _this5._isOldCacheCleared = false;
                _this5.emitError({
                    meta: {},
                    name: 'clearOldCache',
                    stack: e.stack || e.message
                });
            });
        }

        /**
         * get viewport
         * @returns {object} viewport object
         */

    }, {
        key: '_initDB',


        /**
         * init db
         * @param {function} cb callback function
         * @returns {void}
         */
        value: function _initDB(_cb) {
            var _this6 = this;

            var waferDBConfigScriptElem = document.getElementById('wafer-db-config');
            var dbConfig = {};

            if (waferDBConfigScriptElem) {
                try {
                    Object.assign(dbConfig, JSON.parse(waferDBConfigScriptElem.textContent));
                } catch (e) {
                    this.emitError({
                        meta: {},
                        name: 'initDb',
                        stack: e.stack || e.message
                    });
                }
            }
            window.wafer.db = new (_indexDB || _load_indexDB()).default(Object.assign({}, dbConfig, {
                cb: function cb(name) {
                    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                    _cb();
                    switch (name) {
                        case 'success':
                            _this6.emitLog({
                                name: 'IDB-connection-success',
                                meta: meta
                            });
                            break;
                        case 'error':
                            // send error to waferBase
                            _this6.emitError({
                                name: 'IDB',
                                meta: meta
                            });
                            _this6.emitLog({
                                name: 'IDB-connection-error',
                                meta: meta
                            });
                            break;
                        default:
                        // do nothing
                    }
                }
            }));
        }

        /**
         * init config from host
         * host config is the configuration provided by the application to overwrite / control
         * configurations across all the wafers
         * @returns {void}
         */

    }, {
        key: '_initHostConfig',
        value: function _initHostConfig() {
            var waferConfigScriptElem = document.getElementById('wafer-config');

            if (waferConfigScriptElem) {
                try {
                    var config = JSON.parse(waferConfigScriptElem.textContent);

                    var _config$assetsLoaded = config.assetsLoaded,
                        assetsLoaded = _config$assetsLoaded === undefined ? {} : _config$assetsLoaded,
                        others = _objectWithoutProperties(config, ['assetsLoaded']);

                    var _ref7 = window.YAHOO || {},
                        _ref7$context = _ref7.context,
                        context = _ref7$context === undefined ? {} : _ref7$context,
                        _ref7$subscriptions = _ref7.subscriptions,
                        subscriptions = _ref7$subscriptions === undefined ? {} : _ref7$subscriptions;

                    var _ref8 = context || {},
                        rid = _ref8.rid;

                    var _ref9 = subscriptions || {},
                        adLite = _ref9.adLite,
                        crumb = _ref9.crumb;

                    if (rid) {
                        others.rid = rid;
                    }

                    if (adLite && crumb) {
                        others.adLite = adLite;
                        others.subscrumb = crumb;
                    }

                    for (var assetKey in assetsLoaded) {
                        if (assetsLoaded.hasOwnProperty(assetKey)) {
                            this._assetLoadedMapping.set(assetKey, true);
                        }
                    }
                    // this ensures host config is not mutable
                    Object.defineProperty(this, '_hostConfig', {
                        value: others,
                        writable: false
                    });
                } catch (e) {
                    this.emitError({
                        meta: {},
                        name: 'initConfig',
                        stack: e.stack || e.message
                    });
                }
            }
        }

        /**
         * Emit event with data for given type
         * @param {object} data data to emit
         * @param {string} type='error' event type
         * @returns {void}
         */

    }, {
        key: '_emit',
        value: function _emit(data) {
            var _this7 = this;

            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'error';

            // directly call emit of wafer is ready
            if (READY_FNS_EXECUTED) {
                this._ee && this._ee.emit(type, data);
            } else {
                window.wafer.ready(function () {
                    // add a tick to event to ensure we resolve possible race condition for subscribers
                    setTimeout(function () {
                        _this7._ee && _this7._ee.emit(type, data);
                    }, 1);
                });
            }
        }

        /**
         * @private
         * bind color schema change event
         * @returns {void}
         */

    }, {
        key: '_bindColorSchemaChangeEvent',
        value: function _bindColorSchemaChangeEvent() {
            if (this._state.colorSchemaEventAdded) {
                return;
            }
            if (this._props.darkmodeSupportSystemDefault) {
                var bindEvent = window.wafer.utils.bindEvent;


                this._state.colorSchemaEventAdded = true;
                bindEvent(window.matchMedia('(prefers-color-scheme: dark)'), 'change', this._handleColorSchemaChange, {
                    passive: false
                });
            }
        }

        /**
         * @private
         * setup event listeners
         * @returns {void}
         */

    }, {
        key: '_setup',
        value: function _setup() {
            var _this8 = this;

            if (this._ee) {
                return;
            }
            var _window$wafer2 = window.wafer,
                features = _window$wafer2.features,
                utils = _window$wafer2.utils;
            var bindEvent = utils.bindEvent,
                throttle = utils.throttle;
            var isSlowBrowser = features.isSlowBrowser;
            var _document2 = document,
                body = _document2.body;

            var hostConfig = this._hostConfig;

            this._ee = new (_ee || _load_ee()).default();
            this._ee.init();

            if (hostConfig && hostConfig.nativeLazyDisable) {
                features.nativeLazyLoadingSupported = false;
            }

            // expose on method to window.wafer
            window.wafer.on = this._ee.on.bind(this._ee);
            // expose removeListener method to window.wafer
            window.wafer.removeListener = this._ee.removeListener.bind(this._ee);
            // allow setting state from outside to wafer directly(instead of base)
            Object.defineProperty(window.wafer, 'state', {
                configurable: true,
                set: function set(val) {
                    _this8.state = val;
                }
            });

            isSlowBrowser.catch(function () {
                // do nothing
            });
            this._handleResizeWithThrottle = throttle(function () {
                return _this8._handleResize.call(_this8);
            }, RESIZE_DELAY, this);
            this._handleScrollWithThrottle = throttle(function () {
                return _this8._handleScroll.call(_this8);
            }, SCROLL_DELAY, this);
            this._handleDelegatedEvent = this._handleDelegatedEvent.bind(this);
            this._handleKeyDown = this._handleKeyDown.bind(this);
            this._handleColorSchemaChange = this._handleColorSchemaChange.bind(this);
            this._sync = throttle(function (elem) {
                // when calling sync, we dont check for mounted as new elements can contain elements
                // related to unmounted controllers. In such cases, unmounted controllers
                // need to be remounted with events attached
                _this8._wafers.forEach(function (wafer) {
                    wafer.sync && wafer.sync(elem);
                });
                // check if state is present
                // within new markup added
                _this8._updateState(elem);
            }, SYNC_DELAY, this);
            this._saveViewportOffsetWithThrottle = throttle(function () {
                _this8._saveViewportOffset();
            }, SAVE_VIEWPORT_OFFSET_DELAY, this);
            bindEvent(document, window.wafer.features.visibilityMeta.visibilityChange, this._handleVisibilityChange);
            bindEvent(window, 'keydown', this._handleKeyDown, {
                passive: false
            });
            bindEvent(window, 'resize', this._handleResizeWithThrottle);
            bindEvent(window, 'scroll', this._handleScrollWithThrottle);
            bindEvent(body, 'click', this._handleDelegatedEvent, {
                passive: false
            });
            bindEvent(body, 'change', this._handleDelegatedEvent, {
                passive: false
            });
            this._bindColorSchemaChangeEvent();
            window.addEventListener('pageshow', function (event) {
                if (!event.persisted) {
                    window.wafer.ready(function () {
                        setTimeout(function () {
                            _this8.clearOldCache();
                        }, 500);
                    });
                }
            });
            window.addEventListener('pagehide', function (event) {
                // if page is not going to cached, destroy all wafers
                if (event.persisted !== true) {
                    window.wafer.base.destroy(document.body);
                }
            });
        }

        /**
         * update cached viewport with latest values from window/document object
         * @return {void}
         */

    }, {
        key: '_saveViewportOffset',
        value: function _saveViewportOffset() {
            this._viewport.bottom = window.innerHeight || document.documentElement.clientHeight;
            this._viewport.right = window.innerWidth || document.documentElement.clientWidth;
        }

        /**
         * @private
         * update state by merging it
         * @param {object} [elem] dom element
         * @returns {void}
         */

    }, {
        key: '_updateState',
        value: function _updateState() {
            var elem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

            var nodeList = elem.querySelectorAll('script.wafer-state');

            for (var i = 0, scriptElem; scriptElem = nodeList[i]; ++i) {
                // some browsers dont support classList on script tag
                if (!scriptElem.classList) {
                    try {
                        this.state = JSON.parse(scriptElem.textContent);
                    } catch (e) {}
                    return;
                }
                // this check ensures, we dont merge already merged state
                if (!scriptElem.classList.contains('state-added')) {
                    try {
                        this.state = JSON.parse(scriptElem.textContent);
                    } catch (e) {
                        scriptElem.classList.add('state-error');
                    }
                    scriptElem.classList.add('state-added');
                }
            }
        }

        /**
         * @private
         * invoke handleResize for all wafers
         * @param {object} e event object
         * @returns {void}
         */

    }, {
        key: '_handleColorSchemaChange',
        value: function _handleColorSchemaChange() {
            this._wafers.forEach(function (wafer) {
                wafer.handleColorSchemaChange && wafer.handleColorSchemaChange();
            });
        }

        /**
         * @private
         * invoke handleResize for all wafers
         * @returns {void}
         */

    }, {
        key: '_handleResize',
        value: function _handleResize() {
            this._saveViewportOffsetWithThrottle();
            this._ee.emit('resize', {});
            this._wafers.forEach(function (wafer) {
                wafer._state && wafer._state.mounted && wafer.handleResize && wafer.handleResize();
            });
        }

        /**
         * @private
         * handle visibility change
         * similar to other events, notify all wafer controllers when visibility has changed
         * Controllers implementing the method can handle its own logic
         * As part of the handler, visibility param is passed along
         * @returns {void}
         */

    }, {
        key: '_handleVisibilityChange',
        value: function _handleVisibilityChange() {
            var isActive = !document[window.wafer.features.visibilityMeta.hidden];

            this._isPageVisible = isActive;
            this._ee.emit('pageVisibilityChange', {
                isActive: isActive
            });
            // notify all interested wafer controllers
            this._wafers.forEach(function (wafer) {
                // before calling handler, check if wafer controller is mounted
                wafer._state && wafer._state.mounted && wafer.handleVisibilityChange && wafer.handleVisibilityChange(isActive);
            });
        }

        /**
         * @private
         * invoke handleScroll for all wafers
         * @returns {void}
         */

    }, {
        key: '_handleScroll',
        value: function _handleScroll() {
            var coordinates = {
                scrollX: window.scrollX || window.pageXOffset,
                scrollY: window.scrollY || window.pageYOffset
            };

            this._ee.emit('scroll', coordinates);
            this._wafers.forEach(function (wafer) {
                wafer._state && wafer._state.mounted && wafer.handleScroll && wafer.handleScroll(coordinates);
            });
        }

        /**
         * @private
         * add asset on page
         * @param {string} path asset path
         * @param {string} type asset type
         * @returns {promise} resolves when asset is loaded
         */

    }, {
        key: '_loadAsset',
        value: function _loadAsset(path, type) {
            var _this9 = this;

            var _ref10 = this._hostConfig || {},
                _ref10$assetsLoadedHo = _ref10.assetsLoadedHost,
                assetsLoadedHost = _ref10$assetsLoadedHo === undefined ? 's.yimg.com' : _ref10$assetsLoadedHo,
                _ref10$assetsLoadedPr = _ref10.assetsLoadedProtocol,
                assetsLoadedProtocol = _ref10$assetsLoadedPr === undefined ? 'https://' : _ref10$assetsLoadedPr;

            return new Promise(function (resolve) {
                if (_this9._assetLoadedMapping.get(path)) {
                    return resolve();
                }
                // mark it loaded immediately to avoid race conditions
                _this9._assetLoadedMapping.set(path, true);
                var isRelativePath = path.indexOf('/') === 0;
                var src = isRelativePath ? '' + assetsLoadedProtocol + assetsLoadedHost + path : path;

                if (type === 'css') {
                    window.wafer.utils.loadCSSSync({
                        checkPageForLink: true,
                        src: src
                    }, function () {
                        resolve();
                    });
                    return;
                }
                window.wafer.utils.loadScriptAsync({
                    checkPageForScript: true,
                    src: src
                }, function () {
                    resolve();
                });
            });
        }

        /**
         * @private
         * function to get elements path map. Path is from elem to top most element in the tree
         * @param {object} [elem] dom element
         * @returns {map} parentMap map holding nodes in path
         */

    }, {
        key: '_getElementComposedMap',
        value: function _getElementComposedMap(elem) {
            var temp = elem;
            var parentMap = new Map();

            while (temp) {
                parentMap.set(temp, true);
                temp = temp.parentElement;
            }
            return parentMap;
        }

        /**
         * @private
         * @param {object} e event object
         * @returns {void}
         */

    }, {
        key: '_handleDelegatedEvent',
        value: function _handleDelegatedEvent(e) {
            var _this10 = this;

            var target = e.target;

            // logic to handle click outside
            e.waferComposedMap = function () {
                var map = void 0;

                return function () {
                    if (!map) {
                        map = _this10._getElementComposedMap(target);
                    }
                    return {
                        get: function get(node) {
                            // if there is no body, node has been removed from document
                            // due to race conditions, its possible for element to be removed
                            // hence adding get method which explicility checks for body in path
                            if (!map.get(document.body)) {
                                return true;
                            }
                            return map.get(node);
                        }
                    };
                };
            }();
            var node = target;

            this._wafers.forEach(function (wafer) {
                if (wafer._state && wafer._state.mounted) {
                    wafer.handleEvent('clickOutside', node, e);
                    if (node.classList.contains(wafer._options.selector.replace('.', ''))) {
                        wafer.handleEvent(e.type, node, e);
                    }
                }
            });
            node = node.parentElement;
            while (node) {
                this._wafers.forEach(function (wafer) {
                    if (wafer._state && wafer._state.mounted && node.classList.contains(wafer._options.selector.replace('.', ''))) {
                        wafer.handleEvent(e.type, node, e);
                    }
                });
                node = node.parentElement;
            }
        }

        /**
         * @private
         * @param {object} e event object
         * @returns {void}
         */

    }, {
        key: '_handleKeyDown',
        value: function _handleKeyDown(e) {
            var keyCode = e.keyCode;

            // notify all wafers by calling handleKeyDown method

            this._wafers.forEach(function (wafer) {
                if (wafer._state && wafer._state.mounted) {
                    wafer.handleKeyboardDown && wafer.handleKeyboardDown(e);
                }
            });
            if (keyCode === 13) {
                var _target = e.target;

                var node = _target;

                // to ensure we support enter button submit similar to click, we trigger click if keyDown target is button
                if (_target.nodeName.toLowerCase() === 'button') {
                    e.preventDefault(); // its important to cancel default behavior
                    _target.click();
                }

                // similar to click, we bubble keypress so that all parent nodes trigger click for keypress. To ensure we don't
                // trigger click for every node, we check for has-wafer-click classname before triggering click
                while (node.parentNode) {
                    if (node.classList) {
                        var containsWaferClick = node.classList.contains('has-wafer-click');

                        if (node.nodeName.toLowerCase() === 'a' && !containsWaferClick && node.getAttribute('href')) {
                            return;
                        }
                        if (containsWaferClick) {
                            e.preventDefault(); // its important to cancel default behavior
                            node.click();
                        }
                    }
                    node = node.parentNode;
                }
            }
        }

        /**
         * @private
         * @param {string} type method name to execute
         * @param {string} src source
         * @returns {void}
         */

    }, {
        key: '_handleVideoPlayPause',
        value: function _handleVideoPlayPause(type, src) {
            var waferVideo = window.wafer.wafers['wafer-video'];

            if (waferVideo) {
                if (waferVideo.__esModule === true) {
                    waferVideo.default[type].call(waferVideo.default, src);
                } else {
                    waferVideo[type].call(waferVideo, src);
                }
            }
        }

        /* End of Private methods */

    }, {
        key: 'viewport',
        get: function get() {
            return this._viewport;
        }

        /**
         * get state
         * @returns {object} state object
         */

    }, {
        key: 'state',
        get: function get() {
            return this._state;
        }

        /**
         * getter for page visiblity
         * @returns {boolean} true if visible, false if page is not visible
         */
        ,

        /**
         * set state
         * @param {object} newState newsState object which needs to merged with existing state
         */
        set: function set() {
            var _this11 = this;

            var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var _loop = function _loop(key) {
                // ensure we only check direct properties
                if (newState.hasOwnProperty(key)) {
                    // check if current state has value
                    // if current state has value, dont add observer
                    // if current state does not have value, add observer
                    var currentValue = _this11._state[key];

                    if (typeof currentValue === 'undefined') {
                        var observerMapping = _this11._observerMapping || {};
                        Object.defineProperty(_this11._state, key, {
                            configurable: true,
                            get: function get() {
                                return currentValue;
                            },
                            set: function set(newVal) {
                                var observers = observerMapping[key] || [];

                                currentValue = newVal;
                                // yield
                                // invoke all interested observers
                                setTimeout(function () {
                                    for (var i = observers.length - 1; i >= 0; i--) {
                                        observers[i]();
                                    }
                                }, 0);
                            }
                        });
                    }
                    // if object do a shallow merge
                    if (Object(newState[key]) === newState[key]) {
                        _this11._state[key] = _extends({}, _this11._state[key], newState[key]);
                    } else {
                        _this11._state[key] = newState[key];
                    }
                }
            };

            for (var key in newState) {
                _loop(key);
            }
        }

        /**
         * set color schema
         * @param {string} value schema value
         */

    }, {
        key: 'isPageVisible',
        get: function get() {
            return this._isPageVisible;
        }

        /**
         * get isIORetrySupported
         * This getter is used across wafers to disable all IO retries
         * @returns {boolean} true if yes, false if no
         */

    }, {
        key: 'isIORetrySupported',
        get: function get() {
            var _ref11 = this._hostConfig || {},
                _ref11$retryIODisable = _ref11.retryIODisable,
                retryIODisable = _ref11$retryIODisable === undefined ? false : _ref11$retryIODisable;

            if (retryIODisable) {
                return false;
            }
            return true;
        }

        /**
         * get fetchHeaders
         * This getter is used across wafers for adding fetch headers
         * @returns {object} object container fetch headers defined by host
         */

    }, {
        key: 'fetchHeaders',
        get: function get() {
            var _ref12 = this._hostConfig || {},
                _ref12$fetchHeaders = _ref12.fetchHeaders,
                fetchHeaders = _ref12$fetchHeaders === undefined ? {} : _ref12$fetchHeaders;

            return fetchHeaders;
        }

        /**
         * get lang
         * This getter is used across wafers for adding lang
         * The value is typically populated by stitching layer
         * @returns {string} lang
         */

    }, {
        key: 'lang',
        get: function get() {
            var _ref13 = this._hostConfig || {},
                lang = _ref13.lang;

            return lang;
        }

        /**
         * get rid
         * This getter is used across wafers for adding rid
         * @returns {string} rid value
         */

    }, {
        key: 'rid',
        get: function get() {
            var _ref14 = this._hostConfig || {},
                rid = _ref14.rid;

            return rid;
        }

        /**
         * get adLiteConfig
         * This getter is used across wafers for adding adLite and subscrumb
         * @returns {object} adLiteConfig value
         */

    }, {
        key: 'adLiteConfig',
        get: function get() {
            var _ref15 = this._hostConfig || {},
                adLite = _ref15.adLite,
                subscrumb = _ref15.subscrumb;

            return {
                adLite: adLite,
                subscrumb: subscrumb
            };
        }

        /**
         * get aria live region
         * @returns {object} aria live region DOM element
         */

    }, {
        key: 'liveAriaRegion',
        get: function get() {
            if (!this._state) {
                return;
            }
            var liveRegionElem = this._state.liveRegionElem;


            this._state.liveRegionElem = liveRegionElem || document.querySelector('[aria-live="polite"]');

            if (!this._state.liveRegionElem) {
                var _liveRegionElem = this._state.liveRegionElem = document.createElement('div');

                _liveRegionElem.classList.add('Hidden');
                _liveRegionElem.setAttribute('aria-atomic', 'true');
                _liveRegionElem.setAttribute('aria-live', 'polite');
                _liveRegionElem.setAttribute('role', 'alert');
                document.body.appendChild(_liveRegionElem);
            }
            return this._state.liveRegionElem;
        }

        /**
         * get page schema
         * @returns {string} dark or light value
         */

    }, {
        key: 'colorSchema',
        get: function get() {
            if (this._props && !this._props.darkmodeSupportSystemDefault) {
                return this._colorSchemaOverrideTheme;
            }
            var darkSchema = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

            return darkSchema ? 'dark' : 'light';
        }

        /**
         * get page context
         * @returns {object} context object
         */
        ,
        set: function set(value) {
            var isAuto = value === 'auto';

            this._colorSchemaOverrideTheme = isAuto ? undefined : value;
            this._props.darkmodeSupportSystemDefault = !this._colorSchemaOverrideTheme;
            if (isAuto) {
                this._bindColorSchemaChangeEvent();
            }
            this._handleColorSchemaChange();
        }

        /* End of public methods */

        // ------------------------------------------------------------

        /* Private methods */

        /**
         * @private
         * get all wafers
         * @returns {Array} array of all wafers
         */

    }, {
        key: 'pageContext',
        get: function get() {
            var _window = window,
                vzm = _window.vzm,
                YAHOO = _window.YAHOO;


            return YAHOO && YAHOO.context || vzm && vzm.getPageContext && vzm.getPageContext() || {};
        }

        /**
         * get is page is requested by bot
         * @returns {boolean} returns true for bot
         */

    }, {
        key: 'isBot',
        get: function get() {
            var pageContext = window.wafer.base.pageContext;
            var bot = pageContext.bot,
                ynet = pageContext.ynet;

            // don't prefetch for external bot requests

            return bot === '1' && ynet !== '1';
        }
    }, {
        key: '_wafers',
        get: function get() {
            var getWaferForType = window.wafer.utils.getWaferForType;


            return (window.wafer.wafers && Object.keys(window.wafer.wafers) || []).reduce(function (all, current) {
                var wafer = getWaferForType(current);

                all.push(wafer);
                return all;
            }, []);
        }
    }]);

    return WaferController;
}();

if (false) {
    new Promise(function (resolve) {
        require.ensure([], function (require) {
            resolve(require('./decorators/log'));
        });
    }).then(function (logDecorator) {
        if (logDecorator.__esModule === true) {
            logDecorator.default(WaferController);
        } else {
            logDecorator(WaferController);
        }
    });
}
exports.default = WaferController;

/***/ }),

/***/ "./src/entry.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WaferBaseClass = exports.utils = exports.ready = exports.features = exports.controllers = exports.constants = exports.base = undefined;

var _features;

function _load_features() {
    return _features = _interopRequireWildcard(__webpack_require__("./src/features.js"));
}

var _utils;

function _load_utils() {
    return _utils = _interopRequireWildcard(__webpack_require__("./src/utils.js"));
}

var _constants;

function _load_constants() {
    return _constants = _interopRequireDefault(__webpack_require__("./src/constants.js"));
}

var _controller;

function _load_controller() {
    return _controller = _interopRequireDefault(__webpack_require__("./src/controller.js"));
}

var _baseClass;

function _load_baseClass() {
    return _baseClass = __webpack_require__("./src/baseClass/index.js");
}

var _lazyClass;

function _load_lazyClass() {
    return _lazyClass = __webpack_require__("./src/lazyClass/index.js");
}

var _readyQueue;

function _load_readyQueue() {
    return _readyQueue = _interopRequireDefault(__webpack_require__("./src/utils/readyQueue.js"));
}

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var executeAll = (_readyQueue || _load_readyQueue()).default.executeAll,
    ready = (_readyQueue || _load_readyQueue()).default.add;

/* eslint-disable */


if (false) {
    module.hot.accept();
}
/* eslint-enable */
var base = new (_controller || _load_controller()).default();

// add executeAllRegisteredReadyFns to base instance
base.__executeAllRegisteredReadyFns = function () {
    // trigger custom event to handle edge cases
    try {
        var readyEvent = new Event('wafer:ready');

        document.body.dispatchEvent(readyEvent);
    } catch (e) {
        // do nothing
    }
    executeAll();
};
base.supportStateReset = true; // remove in future release

var controllers = {
    WaferBaseController: (_baseClass || _load_baseClass()).WaferBaseController,
    WaferLazyController: (_lazyClass || _load_lazyClass()).WaferLazyController
};

exports.base = base;
exports.constants = (_constants || _load_constants()).default;
exports.controllers = controllers;
exports.features = _features || _load_features();
exports.ready = ready;
exports.utils = _utils || _load_utils();
exports.WaferBaseClass = (_baseClass || _load_baseClass()).WaferBaseClass;

/***/ }),

/***/ "./src/features.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * checks if localStorage is supported by browser
 * @returns {boolean} true if localStorage is supported, false if not supported
 */
var localStorage = exports.localStorage = function () {
    try {
        window.localStorage.setItem('test', 'test');
        window.localStorage.removeItem('test');
        return true;
    } catch (e) {
        return false;
    }
}();

/**
 * get visibilityMeta supported by browser. This method is needed to
 * get the right event name and hidden attribute to be used for document visiblity change event
 * https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
 * @returns {object} visibilityMeta
 */
var visibilityMeta = exports.visibilityMeta = function () {
    var hidden = void 0;
    var visibilityChange = void 0;

    if (typeof document.hidden !== 'undefined') {
        hidden = 'hidden';
        visibilityChange = 'visibilitychange';
    } else if (typeof document.mozHidden !== 'undefined') {
        hidden = 'mozHidden';
        visibilityChange = 'mozvisibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden';
        visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
        visibilityChange = 'webkitvisibilitychange';
    }
    return {
        hidden: hidden, // document attribute to check on visiblity change
        visibilityChange: visibilityChange // event name
    };
}();

/**
 * get supported transform property for the browser
 * @returns {string} tranform property name
 */
var transformProperty = exports.transformProperty = function () {
    var style = document.documentElement.style;
    if (typeof style.transform === 'string') {
        return 'transform';
    }
    return 'WebkitTransform';
}();

/**
 * checks if mutationObserver is supported by browser
 * @returns {boolean} true if mutationObserver is supported, false if not supported
 */
var mutationObserver = exports.mutationObserver = function () {
    var prefixes = ['WebKit', 'Moz', 'O', 'Ms', ''];

    for (var i = 0; i < prefixes.length; i++) {
        if (prefixes[i] + 'MutationObserver' in window) {
            return true;
        }
    }
    return false;
}();

/**
 * checks if browser supports lazy-loading
 * @returns {boolean} true if lazy-loading is supported, false if not supported
 */
var nativeLazyLoadingSupported = exports.nativeLazyLoadingSupported = function () {
    return 'loading' in HTMLImageElement.prototype;
}();

/**
 * checks if browser is slow browser
 * @returns {promise} promise holding true if slow and false if not slow
 */
var isSlowBrowser = exports.isSlowBrowser = function () {
    var LOW_MEMORY_THRESHOLD_PRECENTAGE = 70;
    var slowDevice = void 0;

    return new Promise(function (resolve) {
        if (typeof slowDevice !== 'undefined') {
            return resolve(slowDevice);
        }
        var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

        if (connection) {
            var connectionType = connection.effectiveType;

            // check connection speed
            if (connectionType === 'slow-2g' || connectionType === '2g') {
                slowDevice = true;
                resolve(true); // slow device
                return true;
            }
        }
        // check memory available
        if ('storage' in navigator && 'estimate' in navigator.storage) {
            navigator.storage.estimate().then(function () {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    usage = _ref.usage,
                    quota = _ref.quota;

                var percentUsed = Math.round(usage / quota * 100);

                if (percentUsed >= LOW_MEMORY_THRESHOLD_PRECENTAGE) {
                    slowDevice = true;
                    return resolve(true);
                }
                return resolve(false);
            }).catch(function () {
                return resolve(false);
            });
        } else {
            return resolve(false);
        }
    });
}();

/**
 * checks if performance mark is supported
 * @returns {boolean} true if supported, false if not supported
 */
var performanceMarkSupported = exports.performanceMarkSupported = function () {
    var _window = window,
        performance = _window.performance;

    return performance && 'clearMarks' in performance;
}();

/**
 * Checks if browser is Safari on a touch screen device
 * @returns {boolean} return true if its Safari on a touch device, false if not
 */
var isTouchSafariDevice = exports.isTouchSafariDevice = function () {
    return 'ontouchstart' in window && /Safari/i.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
}();

/**
 * Checks if browser supports smooth scrolling
 * @returns {boolean} return true if browser supports smooth scrolling
 */
var smoothScroll = exports.smoothScroll = function () {
    var supports = false;
    try {
        var div = document.createElement('div');

        div.scrollTo({
            top: 0,
            get behavior() {
                supports = true;
                return 'smooth';
            }
        });
    } catch (err) {} // Edge throws an error
    return supports;
}();

/**
 * Checks if its PWA
 * @returns {boolean} return true if its PWA
 */
var isPWA = exports.isPWA = function () {
    if ('standalone' in window.navigator && window.navigator.standalone) {
        return true;
    }
    // handles browsers supporting matchMedia
    if (typeof window.matchMedia !== 'undefined' && window.matchMedia('(display-mode: standalone)').matches) {
        return true;
    }
    // handles browsers supporting msMatchMedia
    if (typeof window.msMatchMedia !== 'undefined' && window.msMatchMedia('(display-mode: standalone)').matches) {
        return true;
    }
    return false;
}();

/***/ }),

/***/ "./src/lazyClass/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyController;

function _load_lazyController() {
  return _lazyController = __webpack_require__("./src/lazyClass/lazyController.js");
}

Object.defineProperty(exports, 'WaferLazyController', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lazyController || _load_lazyController()).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./src/lazyClass/lazyController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseClass;

function _load_baseClass() {
    return _baseClass = __webpack_require__("./src/baseClass/index.js");
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTR_PREFIX = 'data-wf-';

var IN_PROGRESS_CLASSNAME = 'wafer-lazy-in-progress';

/**
 * handle adding / removing elements from darkmode instances
 * @param {object} elem Element to check
 * @param {map} darkmodeInstances map of darkmodeInstance elements
 * @return {void}
 */
var _handleDarkmodeInstances = function _handleDarkmodeInstances(elem, darkmodeInstances) {
    if (elem.getAttribute('data-wf-has-darkmode')) {
        // check if node is still attached to DOM
        if (!elem.parentNode) {
            darkmodeInstances.delete(elem);
        } else {
            darkmodeInstances.set(elem, true);
        }
    }
};

/**
 * Wafer Lazy controller responsible for lazy loading all
 * images, background-images, pictures and simple videos
 * using viewport detection
 */

var WaferLazyController = function (_WaferBaseController) {
    _inherits(WaferLazyController, _WaferBaseController);

    /**
     * WaferLazyController constructor handles initial setup
     * @param {object} config configs used within the class
     * @param {string} config.containerClass=null classname for containers which have their own scroll
     * @param {string} config.darkSrc=data-wf-darkmode-src data attribute used to store dark mode src
     * @param {function} config.error=false error callback to be called on error of each lazy loading
     * @param {string} config.errorClass=wafer-error classname to add on load failure
     * @param {object} config.root=document root container
     * @param {string} config.selector className of children to be lazy loaded
     * @param {string} config.src=data-wf-src data attribute used to store src
     * @param {function} config.success=false success callback to be called on success of each lazy loading
     * @param {string} config.successClass=wafer-lazy-loaded classname to be added on lazy loading completion
     * @param {number} config.validateDelay=25 throttle threshold for revalidation
     * @param {string} config.WaferClass WaferClass for which instances should be created
     * @return {void}
     */
    function WaferLazyController() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$containerClass = _ref.containerClass,
            containerClass = _ref$containerClass === undefined ? null : _ref$containerClass,
            _ref$darkSrc = _ref.darkSrc,
            darkSrc = _ref$darkSrc === undefined ? 'data-wf-darkmode-src' : _ref$darkSrc,
            _ref$error = _ref.error,
            error = _ref$error === undefined ? false : _ref$error,
            _ref$errorClass = _ref.errorClass,
            errorClass = _ref$errorClass === undefined ? 'wafer-error' : _ref$errorClass,
            _ref$root = _ref.root,
            root = _ref$root === undefined ? document : _ref$root,
            selector = _ref.selector,
            _ref$src = _ref.src,
            src = _ref$src === undefined ? 'data-wf-src' : _ref$src,
            _ref$success = _ref.success,
            success = _ref$success === undefined ? false : _ref$success,
            _ref$successClass = _ref.successClass,
            successClass = _ref$successClass === undefined ? 'wafer-lazy-loaded' : _ref$successClass,
            _ref$validateDelay = _ref.validateDelay,
            validateDelay = _ref$validateDelay === undefined ? 25 : _ref$validateDelay,
            WaferClass = _ref.WaferClass;

        _classCallCheck(this, WaferLazyController);

        var _this = _possibleConstructorReturn(this, (WaferLazyController.__proto__ || Object.getPrototypeOf(WaferLazyController)).call(this, {
            root: root,
            selector: selector
        }));

        var throttle = window.wafer.utils.throttle;


        _this._options = _extends({}, _this._options, {
            container: containerClass ? root.getElementsByClassName(containerClass) : false,
            containerClass: containerClass,
            darkSrc: darkSrc,
            error: error,
            errorClass: errorClass,
            isRetina: window.devicePixelRatio > 1,
            src: src,
            success: success,
            successClass: successClass,
            WaferClass: WaferClass
        });
        _this._state = _extends({}, _this._state, {
            darkmodeInstances: new Map() // map of darkmode instances. We created separate map to ensure delete of default instance still has source of truth for darkmode operations
        });
        // throttle, ensures that we don't call the functions too often
        _this._validateWithThrottle = throttle(function () {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                source = _ref2.source;

            _this.validate({ source: source });
        }, validateDelay, _this);
        return _this;
    }

    /* Public methods */

    /**
     * handles logic to load element by checking all stored elements
     * for either of the condition
     * - intersection with cached view-port
     * OR - having success class
     * @return {void}
     */


    _createClass(WaferLazyController, [{
        key: 'handleScroll',
        value: function handleScroll() {
            this._validateWithThrottle({ source: 'scroll' });
        }

        /**
         * handles logic to load element by checking all stored elements
         * for either of the condition
         * - intersection with cached view-port
         * OR - having success class
         * @return {void}
         */

    }, {
        key: 'handleResize',
        value: function handleResize() {
            this._validateWithThrottle();
        }

        /* End of public methods */

        // ------------------------------------------------------------

        /* Life cycle methods */

        /**
         * responsible for following
         * - unbind events for containers if containerClass is provided
         * @return {void}
         */

    }, {
        key: 'willDestroy',
        value: function willDestroy() {
            var _this2 = this;

            var container = this._options.container;

            if (container) {
                var _window$wafer$utils = window.wafer.utils,
                    each = _window$wafer$utils.each,
                    unbindEvent = _window$wafer$utils.unbindEvent;


                each(container, function (object) {
                    unbindEvent(object, 'scroll', _this2._validateWithThrottle);
                });
            }
        }

        /**
         * responsible for following
         * - add scroll listener to containers if containerClass is provided
         * @return {void}
         */

    }, {
        key: 'didSync',
        value: function didSync() {
            var _this3 = this;

            var _state = this._state,
                elementInstances = _state.elementInstances,
                mounted = _state.mounted;

            // bind resize and scroll events if not already binded
            // to check if events are not bound, we use mounted flag

            if (elementInstances.size !== 0) {
                var _options = this._options,
                    container = _options.container,
                    _options$defaultOffse = _options.defaultOffsetY,
                    defaultOffsetY = _options$defaultOffse === undefined ? 100 : _options$defaultOffse,
                    _options$defaultOffse2 = _options.defaultOffsetX,
                    defaultOffsetX = _options$defaultOffse2 === undefined ? 0 : _options$defaultOffse2;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {

                    for (var _iterator = elementInstances.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _step$value = _slicedToArray(_step.value, 2),
                            elem = _step$value[0],
                            _step$value$ = _step$value[1];

                        _step$value$ = _step$value$ === undefined ? {} : _step$value$;
                        var offsetX = _step$value$.offsetX,
                            offsetY = _step$value$.offsetY;

                        if (typeof offsetX === 'undefined' || typeof offsetY === 'undefined') {
                            var entityData = elementInstances.get(elem);

                            var _split = (elem.getAttribute(ATTR_PREFIX + 'margin') || '').split(' '),
                                _split2 = _slicedToArray(_split, 2),
                                assignedOffsetY = _split2[0],
                                assignedOffsetX = _split2[1];

                            entityData.offsetY = Number(assignedOffsetY) || defaultOffsetY;
                            entityData.offsetX = Number(assignedOffsetX) || defaultOffsetX;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                if (!mounted) {
                    this._state.mounted = true;

                    if (container) {
                        var _window$wafer$utils2 = window.wafer.utils,
                            bindEvent = _window$wafer$utils2.bindEvent,
                            each = _window$wafer$utils2.each;


                        each(container, function (object) {
                            bindEvent(object, 'scroll', _this3._validateWithThrottle);
                        });
                    }
                }
            }
        }

        /**
         * handles logic to load element by checking all stored elements
         * for either of the condition
         * - intersection with current viewport OR having success class
         * - once element is present within viewport, remove element from elementInstances map
         * @param {object} elems Array-like DOM collection (this is not array)
         * @param {object} params Additional params
         * @param {string} params.source callee source for validate
         * @return {void}
         */

    }, {
        key: 'willValidate',
        value: function willValidate(elems) {
            var _this4 = this;

            var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                source = _ref3.source;

            var _state2 = this._state,
                elementInstances = _state2.elementInstances,
                darkmodeInstances = _state2.darkmodeInstances;
            var _window$wafer = window.wafer,
                base = _window$wafer.base,
                features = _window$wafer.features,
                utils = _window$wafer.utils;
            var elementInView = utils.elementInView;

            var options = this._options;
            var nativeLazyLoadingSupported = features.nativeLazyLoadingSupported;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                var _loop = function _loop() {
                    var _step2$value = _slicedToArray(_step2.value, 2),
                        elem = _step2$value[0],
                        _step2$value$ = _step2$value[1];

                    _step2$value$ = _step2$value$ === undefined ? {} : _step2$value$;
                    var offsetX = _step2$value$.offsetX,
                        offsetY = _step2$value$.offsetY;

                    var isLocked = parseInt(elem.getAttribute('data-wf-lock'), 10);

                    if (isLocked) {
                        return 'continue';
                    }
                    var trigger = elem.getAttribute(ATTR_PREFIX + 'trigger') || 'viewport';
                    var tagName = elem.tagName.toLowerCase();

                    if (trigger === 'onLoad' || source === 'scroll' && trigger === 'onScroll') {
                        _this4._load(elem).then(function () {
                            elementInstances.delete(elem);
                            _handleDarkmodeInstances(elem, darkmodeInstances);
                        }).catch(function () {
                            // don't do anything
                        });
                    } else if (nativeLazyLoadingSupported && (tagName === 'img' || tagName === 'picture') && _this4.nativeLazyLoadElement) {
                        _this4.nativeLazyLoadElement(elem);
                        elementInstances.delete(elem);
                        _handleDarkmodeInstances(elem, darkmodeInstances);
                    } else if (trigger === 'viewport') {
                        if (elementInView(elem, _extends({}, options, {
                            offsetX: offsetX,
                            offsetY: offsetY
                        }), base.viewport) || elem.classList.contains(options.successClass)) {
                            if (elem.classList.contains(IN_PROGRESS_CLASSNAME)) {
                                return {
                                    v: void 0
                                };
                            }
                            elem.classList.add(IN_PROGRESS_CLASSNAME);
                            _this4._load(elem).then(function () {
                                elementInstances.delete(elem);
                                _handleDarkmodeInstances(elem, darkmodeInstances);
                                elem.classList.remove(IN_PROGRESS_CLASSNAME);
                            }).catch(function () {
                                elem.classList.remove(IN_PROGRESS_CLASSNAME);
                            });
                        }
                    }
                };

                for (var _iterator2 = elementInstances.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _ret = _loop();

                    switch (_ret) {
                        case 'continue':
                            continue;

                        default:
                            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }

        /* End of Life cycle methods */

        // ------------------------------------------------------------

        /* Private methods */

        /**
         * Tests whether the element should be loaded
         * @param {object} elem Array-like DOM collection (this is not array)
         * @return {boolean} True if element should be loaded
         */

    }, {
        key: '_shouldLoadElement',
        value: function _shouldLoadElement(elem) {
            var successClass = this._options.successClass;


            return !elem.classList.contains(successClass);
        }

        /**
         * invoke derived wafer controller load
         *  - use timeout if element has timeout attribute
         *      - when timeout is available, maintain pending state
         *      - to ensure loadElement is called only once
         * - if no timeout is set, call load immediately
         * @param {object} elem DOM element
         * @return {void}
         */

    }, {
        key: '_loadElement',
        value: function _loadElement(elem) {
            var _this5 = this;

            return new Promise(function (resolve, reject) {
                var elementInstances = _this5._state.elementInstances;


                var elemInstance = elementInstances.get(elem);
                var timeout = parseInt(elem.getAttribute(ATTR_PREFIX + 'timeout'), 10) || 0;

                if (elemInstance.pending !== true) {
                    if (timeout) {
                        setTimeout(function () {
                            _this5.loadElement(elem).then(function () {
                                resolve();
                            }).catch(function (err) {
                                elemInstance.pending = false;
                                reject(err);
                            });
                        }, timeout);
                    } else {
                        _this5.loadElement(elem).then(function () {
                            resolve();
                        }).catch(function (err) {
                            elemInstance.pending = false;
                            reject(err);
                        });
                    }
                    elemInstance.pending = true;
                } else {
                    reject(new Error('execution is pending'));
                }
            });
        }

        /**
         * load(images/background-images/pictures/videos) from the stored elements
         * @param {object} elem DOM elem
         * @return {void}
         */

    }, {
        key: '_load',
        value: function _load(elem) {
            return this._loadElement(elem);
        }

        /**
         * responsible for following
         * - Add success class to element
         * - Remove src attribute from element
         * @param {object} elem dom element
         * @return {void}
         */

    }, {
        key: '_itemLoaded',
        value: function _itemLoaded(elem) {
            var _options2 = this._options,
                selector = _options2.selector,
                success = _options2.success,
                successClass = _options2.successClass;
            // remove selector class to avoid unnecessary iteration
            // of given element during syncing

            elem.classList.remove(selector.replace('.', ''));
            elem.classList.add(successClass);
            if (success) {
                success(elem);
            }
        }
        /* End of Private methods */

    }]);

    return WaferLazyController;
}((_baseClass || _load_baseClass()).WaferBaseController);

if (false) {
    new Promise(function (resolve) {
        require.ensure([], function (require) {
            resolve(require('../decorators/log'));
        });
    }).then(function (logDecorator) {
        if (logDecorator.__esModule === true) {
            logDecorator.default(WaferLazyController);
        } else {
            logDecorator(WaferLazyController);
        }
    });
}

exports.default = WaferLazyController;
module.exports = exports['default'];

/***/ }),

/***/ "./src/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setTimeout = exports.clearTimeoutForInstance = exports.clearTimeout = exports.clearAllTimeout = exports.getCookie = exports.setCookie = exports.removeCookie = exports.fetchWithCache = exports.urlify = exports.removeTransition = exports.setTransition = exports.getUrlParameterValueByName = exports.getDataYlk = exports.getYlkMapForNode = exports.getFocusableElems = exports.getWaferInstanceForElem = exports.getWaferForType = exports.getTemplateContent = exports.getConfigFromJSONScriptNode = exports.clearAndSetInnerHTML = exports.convertNodeListToArray = exports.getElementsByAttrValues = exports.parseUrl = exports.isNodeName = exports.fireBeacon = exports.findAncestor = exports.each = exports.loadCSSSync = exports.loadScriptAsync = exports.get = exports.unbindEvent = exports.bindEvent = exports.throttle = exports.elementInView = exports.debounce = exports.isVisible = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _utils;

function _load_utils() {
    return _utils = __webpack_require__("./src/utils/utils.js");
}

var _cookie;

function _load_cookie() {
    return _cookie = __webpack_require__("./src/utils/cookie.js");
}

var _timeout;

function _load_timeout() {
    return _timeout = __webpack_require__("./src/utils/timeout.js");
}

var _features;

function _load_features() {
    return _features = __webpack_require__("./src/features.js");
}

var clearAllTimeoutUtil = (_timeout || _load_timeout()).timeout.clearAllTimeout,
    clearTimeoutUtil = (_timeout || _load_timeout()).timeout.clearTimeout,
    clearTimeoutForInstanceUtil = (_timeout || _load_timeout()).timeout.clearTimeoutForInstance,
    setTimeoutUtil = (_timeout || _load_timeout()).timeout.setTimeout;

var FOCUS_ELEMENT_QUERY = 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="search"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])';

/* Private helper functions
 ************************************/

/**
 * @private
 * Checks for intersection of rect and viewport
 * @param {object} rect size and position of dom element
 * @param {object} viewport size and position of viewport
 * @param {number} offset.offsetX offset x for intersection
 * @param {number} offset.offsetY offset y for intersection
 * @returns {boolean} true if it intersects, false if it does not intersect
 */
var _inView = function _inView(rect, viewport) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$offsetX = _ref.offsetX,
        offsetX = _ref$offsetX === undefined ? 0 : _ref$offsetX,
        _ref$offsetY = _ref.offsetY,
        offsetY = _ref$offsetY === undefined ? 0 : _ref$offsetY;

    // Intersection
    return rect.right + offsetX >= viewport.left && rect.bottom + offsetY >= viewport.top && rect.left - offsetX <= viewport.right && rect.top - offsetY <= viewport.bottom;
};

/**
 * @private
 * Checks if DOM element is visible
 * @param {object} elem dom element
 * @returns {boolean} return true if visible, false if not visible
 */
var _isVisible = function _isVisible(elem) {
    return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
};

/**
 * @private
 * Checks if style href has been added to DOM
 * @param {string} href stylesheet href
 * @returns {boolean} return true if added, false if not added
 */
var _checkIfCSSHasBeenMounted = function _checkIfCSSHasBeenMounted(href) {
    var _document = document,
        styleSheets = _document.styleSheets;


    for (var i = 0; i < styleSheets.length; i++) {
        var styleSheet = styleSheets[i];

        if (styleSheet.href === href) {
            return true;
        }
    }
    return false;
};

/**
 * @private
 * Get elements with attribute value and insert into map object provided
 * @param {string} attr attribute key name
 * @param {Array} values attribute value
 * @param {object} elem dom element
 * @param {object} map map to insert data
 * @return {array} elements containing attribute with value for given element
 */
var _getElementsByAttrValues = function _getElementsByAttrValues(attr, values, elem, map) {
    if (elem.hasAttribute(attr)) {
        var attrVal = elem.getAttribute(attr);
        map[attrVal] && map[attrVal].push(elem);
    }

    var children = elem.children;

    if (!children) {
        return map;
    }

    for (var i = children.length; i--;) {
        _getElementsByAttrValues(attr, values, children[i], map);
    }
    return map;
};

/**
 * Get template element for given template node
 * @param {object} elem dom element
 * @return {object} template dom element
 */
var _getTemplateNode = function _getTemplateNode(elem) {
    if (!elem) {
        return elem;
    }
    if ('content' in document.createElement('template')) {
        return elem;
    } else {
        var children = elem.childNodes;
        var templateElem = void 0;

        if (!children.length) {
            templateElem = elem;
        } else {
            templateElem = document.createElement('div');

            for (var i = 0; i < children.length; i++) {
                templateElem.appendChild(children[i].cloneNode(true));
            }
            window.wafer.base.destroy(elem); // remove wafers from this element
            elem.innerHTML = '';
        }
        return templateElem;
    }
};

/* End of Private helper functions
 ************************************/

/**
 * Checks if DOM element is visible
 * @param {object} elem dom element
 * @returns {boolean} return true if visible, false if not visible
 */
var isVisible = exports.isVisible = _isVisible;

/**
 * @param {function} fn function to be debounced and executed
 * @param {Number} delay time of debounce delay, in ms
 * @param {Object} scope function context to be bound
 * @returns {function}  new function which holds fn
 */
var debounce = exports.debounce = function debounce(fn, delay, scope) {
    var timer = void 0;

    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
            fn.apply(scope, args);
        }, delay);
    };
};

/**
 * Checks if element is within given viewport
 * @param {object} elem dom element
 * @param {object} options configuration options
 * @param {string} options.containerClass container class
 * @param {number} options.offsetX offset x for intersection
 * @param {number} options.offsetY offset y for intersection
 * @param {object} viewport size and position of viewport
 * @returns {boolean} true if in view, false if not in view
 */
var elementInView = exports.elementInView = function elementInView(elem) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        containerClass = _ref2.containerClass,
        _ref2$offsetX = _ref2.offsetX,
        offsetX = _ref2$offsetX === undefined ? 0 : _ref2$offsetX,
        _ref2$offsetY = _ref2.offsetY,
        offsetY = _ref2$offsetY === undefined ? 0 : _ref2$offsetY;

    var viewport = arguments[2];

    var isVisible = _isVisible(elem);

    if (!isVisible) {
        return false;
    }
    if (containerClass && Element.prototype.closest) {
        // Is element inside a container?
        var elementContainer = elem.closest(containerClass);
        if (elementContainer) {
            var containerRect = elementContainer.getBoundingClientRect();
            // Is container in view?
            if (_inView(containerRect, viewport)) {
                var bottom = containerRect.bottom + offsetY;
                var left = containerRect.left - offsetX;
                var right = containerRect.right + offsetX;
                var top = containerRect.top - offsetY;

                var containerRectWithOffset = {
                    top: top > viewport.top ? top : viewport.top,
                    right: right < viewport.right ? right : viewport.right,
                    bottom: bottom < viewport.bottom ? bottom : viewport.bottom,
                    left: left > viewport.left ? left : viewport.left
                };
                var _rect = elem.getBoundingClientRect();

                // Is element in view of container?
                return _inView(_rect, containerRectWithOffset);
            }
            return false;
        }
    }
    var rect = elem.getBoundingClientRect();
    return _inView(rect, viewport, {
        offsetX: offsetX,
        offsetY: offsetY
    });
};

/**
 * Throttle function execution
 * @param {function} fn function to be throttled and executed
 * @param {number} minDelay delay for thorttling
 * @param {object} scope function context to be bound
 * @returns {function} new function which holds fn
 */
var throttle = exports.throttle = function throttle(fn, minDelay, scope) {
    var lastCall = 0;
    return function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        var now = +new Date();
        if (now - lastCall < minDelay) {
            return;
        }
        lastCall = now;
        fn.apply(scope, args);
    };
};

/**
 * Bind event
 * @param {object} elem dom element
 * @param {string} type of event
 * @param {function} fn function to bind
 * @param {object} options configuration options
 * @param {boolean} options.passive=true should event be passive
 * @returns {void}
 */
var bindEvent = exports.bindEvent = function bindEvent(elem, type, fn) {
    var _ref3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref3$passive = _ref3.passive,
        passive = _ref3$passive === undefined ? true : _ref3$passive;

    if ((_features || _load_features()).isTouchSafariDevice && type === 'click') {
        elem.style.cursor = 'pointer'; // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html#c14825
    }
    elem.addEventListener(type, fn, { capture: false, passive: passive });
};

/**
 * Unbind event
 * @param {object} elem dom element
 * @param {string} type of event
 * @param {function} fn function to bind
 * @param {object} options configuration options
 * @param {boolean} options.passive=true was event passive
 * @returns {void}
 */
var unbindEvent = exports.unbindEvent = function unbindEvent(elem, type, fn) {
    var _ref4 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref4$passive = _ref4.passive,
        passive = _ref4$passive === undefined ? true : _ref4$passive;

    elem.removeEventListener(type, fn, { capture: false, passive: passive });
};

/**
 * Get path value in object
 * @param {object} obj object to check
 * @param {array} keys path
 * @return {object} object if exists, else null
 */
var get = exports.get = function get(obj, keys) {
    return keys.reduce(function (xs, x) {
        return xs && xs[x];
    }, obj);
};

/**
 * Load script async
 * @param {object} config - config
 * @param {boolean} config.checkPageForScript=false - check if page has script
 * @param {string} config.src - script path to load
 * @param {type} config.type=text/javascript - script type
 * @param {string} config.text - text to be executed
 * @param {function} callback - callback to call if script is loaded or if namespace is already available
 * @param {string} namespace - namespace to check if script is already available
 * @param {number} retryIndex - retry index
 * @returns {void}
 */
var loadScriptAsync = exports.loadScriptAsync = function loadScriptAsync() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref5$checkPageForScr = _ref5.checkPageForScript,
        checkPageForScript = _ref5$checkPageForScr === undefined ? false : _ref5$checkPageForScr,
        src = _ref5.src,
        type = _ref5.type,
        text = _ref5.text;

    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var namespace = arguments[2];
    var retryIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    if (namespace) {
        if (get(window, namespace.split('.'))) {
            callback();
            return;
        }
    }
    type = type || 'text/javascript';
    if (type !== 'text/javascript') {
        callback(new Error('can load only script of type text/javascript'));
        return;
    }
    if (src && checkPageForScript && document.querySelector('script[src*="' + src + '"]')) {
        callback();
        return;
    }
    var script = document.createElement('script');

    script.type = type;
    if (src) {
        script.src = src;
        script.async = true;
        script.defer = true;
        if (script.readyState) {
            // IE, incl. IE9
            script.onreadystatechange = function () {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    script.onreadystatechange = null;
                    callback(null, script);
                }
            };
        } else {
            script.onload = function () {
                // Other browsers
                callback(null, script);
            };
        }
        script.onerror = function () {
            if (retryIndex <= 5) {
                loadScriptAsync({ src: src, type: type, text: text }, callback, namespace, ++retryIndex);
            } else {
                callback(new Error('could not load script'));
            }
        };
    } else {
        script.textContent = 'try{' + text + '}catch(e){window.console && window.console.error(e);}';
        callback(null, script);
    }
    document.getElementsByTagName('head')[0].appendChild(script);
};

/**
 * Load css
 * @param {object} config - config
 * @param {boolean} config.checkPageForLink=false - check if page has script
 * @param {string} config.src - css path to load
 * @param {string} config.text - inline css content to be added
 * @param {function} callback - callback to call if css is loaded
 * @param {number} retryIndex - retry index
 * @returns {void}
 */
var loadCSSSync = exports.loadCSSSync = function loadCSSSync() {
    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref6$checkPageForLin = _ref6.checkPageForLink,
        checkPageForLink = _ref6$checkPageForLin === undefined ? false : _ref6$checkPageForLin,
        src = _ref6.src,
        text = _ref6.text;

    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var retryIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    if (src && checkPageForLink && document.querySelector('link[href*="' + src + '"]')) {
        callback();
        return;
    }
    var h = document.getElementsByTagName('head')[0];

    if (text) {
        var style = document.createElement('style');

        style.type = 'text/css';
        if (style.styleSheet) {
            style.styleSheet.cssText = text;
        } else {
            style.appendChild(document.createTextNode(text));
        }
        h.appendChild(style);
        callback();
        return;
    }
    var l = document.createElement('link');

    l.rel = 'stylesheet';
    l.href = src;
    h.appendChild(l);
    l.addEventListener('load', function () {
        if (_checkIfCSSHasBeenMounted(src)) {
            callback();
            return;
        }
        var retryCount = 0;
        // if css was not added, retry it twice before executing callback
        var retryInstance = setInterval(function () {
            if (_checkIfCSSHasBeenMounted(src) || retryCount > 2) {
                callback();
                clearInterval(retryInstance);
            }
            ++retryCount;
        }, 10); // check every 10 ms
    });
    l.addEventListener('error', function () {
        if (retryIndex <= 2) {
            loadCSSSync({ src: src, text: text }, callback, ++retryIndex);
        } else {
            callback();
        }
    });
};

/**
 * Iterate dom array and call function for each by passing dom element and index
 * @param {array} elems dom array(like Array but not Array)
 * @param {function} fn function to be called for each dom array element
 * @returns {void}
 */
var each = exports.each = function each(elems, fn) {
    if (elems && fn) {
        var l = elems.length;
        for (var i = 0; i < l && fn(elems[i], i) !== false; i++) {
            // do nothing
        }
    }
};

/**
 * Find first ancestor for element having provided class name
 * @param {object} elem dom element
 * @param {string} className classname of ancestor to find
 * @returns {object} elem ancestor dom element which has provided class name
 */
var findAncestor = exports.findAncestor = function findAncestor(elem, className) {
    while (elem && !elem.classList.contains(className)) {
        elem = elem.parentElement;
    }
    return elem;
};

/**
 * Fire beacon using navigator sendBeacon if available or by creating image
 * @param {string} url beacon url to fire
 * @param {boolean} config.useNavigator=true flag to use window.navigator if available
 * @returns {void}
 */
var fireBeacon = exports.fireBeacon = function fireBeacon(url) {
    var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref7$useNavigator = _ref7.useNavigator,
        useNavigator = _ref7$useNavigator === undefined ? true : _ref7$useNavigator,
        _ref7$useTimestamp = _ref7.useTimestamp,
        useTimestamp = _ref7$useTimestamp === undefined ? true : _ref7$useTimestamp;

    // useImg helps identify beacon destination source of loading
    // if beacon was triggered by useImg request
    var useImg = false;

    if (useNavigator) {
        if (window.navigator && typeof window.navigator.sendBeacon === 'function') {
            try {
                if (!window.navigator.sendBeacon(url)) {
                    // if sendBeacon() returns false, use image beacon
                    useImg = true;
                }
            } catch (err) {
                // if sendBeacon() throws an exception, use image beacon
                useImg = true;
            }
        } else {
            // if API is not available, use image beacon
            useImg = true;
        }
    } else {
        useImg = true;
    }
    if (useImg) {
        var img = new Image();

        bindEvent(img, 'error', function () {
            img = null;
        });
        bindEvent(img, 'load', function () {
            img = null;
        });
        bindEvent(img, 'abort', function () {
            img = null;
        });
        if (useTimestamp) {
            img.src = url + (url.indexOf('?') === -1 ? '?' : '&') + new Date().getTime();
        } else {
            img.src = url;
        }
    }
};

/**
 * Check if element nodeName exactly matches
 * Checking is case insensitive
 * @param {object} elem dom element
 * @param {string} nodeName name to check
 * @returns {boolean} true if exactly matches, false if it does not match
 */
var isNodeName = exports.isNodeName = function isNodeName(elem, nodeName) {
    return elem.nodeName.toLowerCase() === nodeName;
};

/**
 * Parse url and get host and pathname
 * @param {string} url url to parse
 * @param {object} object containing hostname and pathname
 * @param {string} object.host hostname for given url
 *   Some prop.
 * @return {string} object.pathname path for given url
 */
var parseUrl = exports.parseUrl = function parseUrl(url) {
    url = url ? url.split('?')[0] : '';
    if (!url || url.charAt(0) === '/') {
        return {
            host: typeof window !== 'undefined' ? window.location.host : '',
            pathname: url || ''
        };
    }

    // very basic absolute URL parsing
    var urlParts = url.split('/');
    return {
        host: urlParts[2],
        pathname: '/' + urlParts.slice(3).join('/')
    };
};

/**
 * Get elements containing attribute with value for given dom element
 * @param {string} attr attribute key name
 * @param {Array} values attribute value
 * @param {object} elem dom element
 * @return {array} elements containing attribute with value for given element
 */
var getElementsByAttrValues = exports.getElementsByAttrValues = function getElementsByAttrValues(attr, values) {
    var elem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document.body;

    if (!Array.isArray(values)) {
        return {};
    }

    var map = {};

    values.forEach(function (val) {
        map[val] = [];
    });
    _getElementsByAttrValues(attr, values, elem, map);
    return map;
};

/**
 * Convert nodeList to array
 * @param {NodeList} nodeList list of nodes
 * @return {array} converted array
 */
var convertNodeListToArray = exports.convertNodeListToArray = function convertNodeListToArray(nodeList) {
    var arr = [];

    for (var i = 0, node; node = nodeList[i]; ++i) {
        arr.push(node);
    }
    return arr;
};

/**
 * Use this wrapper method if you are updating existing DOM element innerHTML. This method ensures we clear innerHTML before replacing it
 * @param {object} elem dom element
 * @param {string} html string to use as innerHTML
 * @returns {void}
 */
var clearAndSetInnerHTML = exports.clearAndSetInnerHTML = function clearAndSetInnerHTML(elem, html) {
    elem.innerHTML = ''; // first reset html. This is needed to ensure web-components lifecycle is executed appropriately
    elem.innerHTML = html;
};

/**
 * JSON parse script text content and return parsed output on success and empty object on failure
 * @param {object} elem dom element
 * @return {object} object parsed
 */
var getConfigFromJSONScriptNode = exports.getConfigFromJSONScriptNode = function getConfigFromJSONScriptNode(elem) {
    if (!elem) {
        return {};
    }
    var val = {};

    try {
        val = JSON.parse(elem.textContent);
    } catch (e) {
        // do nothing
    }
    return val;
};

/**
 * Get template node content
 * @param {object} elem template dom element
 * @return {string} template inner content
 */
var getTemplateContent = exports.getTemplateContent = function getTemplateContent(elem) {
    var templateElem = _getTemplateNode(elem);
    var innerHTML = templateElem.innerHTML;


    if (innerHTML) {
        return innerHTML;
    }
    // below code was added to handle React rendering on client. We noticed that React empties document fragment
    // and adds children of the fragment as direct children of template Node. This confuses browser DOM API and returns
    // empty string for template innerHTML. As a workaround, we now extract outerHTML of every childNode and join it to retrieve
    // the innerHTML of the template node. We noticed this issue on React 15. React 16+ was not tested.
    var html = '';
    var children = templateElem.childNodes;

    for (var i = 0; i < children.length; i++) {
        html += children[i].outerHTML;
    }
    return html;
};

/**
 * Get wafer for type
 * @param {string} type wafer type
 * @return {object} wafer instance
 */
var getWaferForType = exports.getWaferForType = function getWaferForType(type) {
    var waferType = window.wafer.wafers[type];

    if (!waferType) {
        return null;
    }
    if (waferType.__esModule === true) {
        return waferType.default;
    }
    return waferType;
};

/**
 * Get wafer instance for element and type
 * @param {object} elem DOM element for which instance is needed
 * @param {string} type wafer type
 * @return {object} wafer instance
 */
var getWaferInstanceForElem = exports.getWaferInstanceForElem = function getWaferInstanceForElem(elem, type) {
    var waferType = getWaferForType(type);

    if (!waferType) {
        return null;
    }
    var waferTypeState = waferType._state;

    return waferTypeState.elementInstances.get(elem);
};

/**
 * Get focusable elements for given element
 * @param {object} elem DOM element for which instance is needed
 * @return {array} array of focusable element
 */
var getFocusableElems = exports.getFocusableElems = function getFocusableElems(elem) {
    return elem.querySelectorAll(FOCUS_ELEMENT_QUERY);
};

/**
 * get ylk map fr node
 * @param {DOM} elem DOM node for which you need ylk map
 * @param {string} attr=data-ylk attribute name to use for key value pair
 * @return {object} ylkMap ylk object map
 */
var getYlkMapForNode = exports.getYlkMapForNode = function getYlkMapForNode(elem) {
    var attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data-ylk';

    var elemYlk = elem.getAttribute(attr) || elem.getAttribute('data-i13n');
    var ylkMap = {};

    elemYlk && elemYlk.split(';').forEach(function (ylkItem) {
        var _ylkItem$split = ylkItem.split(':'),
            _ylkItem$split2 = _slicedToArray(_ylkItem$split, 2),
            key = _ylkItem$split2[0],
            value = _ylkItem$split2[1];

        if (!ylkMap[key] && value) {
            ylkMap[key] = value;
        }
    });
    return ylkMap;
};

/**
 * Get hierarchy of ylk for given element
 * @param {object} elem DOM element for which instance is needed
 * @return {object} ylk map
 */
var getDataYlk = exports.getDataYlk = function getDataYlk(elem) {
    var ylkMap = {};
    var currentElem = elem;
    var id = currentElem.getAttribute('id');

    if (id) {
        ylkMap.id = id;
    }
    while (currentElem !== document.body) {
        Object.assign(ylkMap, getYlkMapForNode(currentElem));
        currentElem = currentElem.parentNode;
    }
    return ylkMap;
};

/**
 * getUrlParameterValueByName
 * get value for query string in url
 * @param {string} name - query name
 * @param {string} url - url to check
 * @return {string} value of query string
 */
var getUrlParameterValueByName = exports.getUrlParameterValueByName = function getUrlParameterValueByName(name, url) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(url);

    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};

/**
 * set transition property for element
 * @param {object} elem - DOM element
 * @param {string} property - transition property
 * @param {string} duration - transition duration
 * @param {string} timingFunction - transition timingFunction
 * @return {void}
 */
var setTransition = exports.setTransition = function setTransition(elem, property, duration, timingFunction) {
    var val = property + ' ' + duration + 'ms ' + timingFunction;

    Object.assign(elem.style, {
        webkitTransition: val,
        transition: val
    });
};

/**
 * clear transition property for element
 * @param {object} elem - DOM element
 * @return {void}
 */
var removeTransition = exports.removeTransition = function removeTransition(elem) {
    Object.assign(elem.style, {
        webkitTransition: '',
        transition: ''
    });
};

var urlify = exports.urlify = (_utils || _load_utils()).urlify;

var fetchWithCache = exports.fetchWithCache = (_utils || _load_utils()).fetchWithCache;

var removeCookie = exports.removeCookie = (_cookie || _load_cookie()).remove;

var setCookie = exports.setCookie = (_cookie || _load_cookie()).set;

var getCookie = exports.getCookie = (_cookie || _load_cookie()).get;

var clearAllTimeout = exports.clearAllTimeout = clearAllTimeoutUtil;

var clearTimeout = exports.clearTimeout = clearTimeoutUtil;

var clearTimeoutForInstance = exports.clearTimeoutForInstance = clearTimeoutForInstanceUtil;

var setTimeout = exports.setTimeout = setTimeoutUtil;

/***/ }),

/***/ "./src/utils/cookie.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _isValidString = function _isValidString(str) {
    return typeof str === 'string' && str;
};
var COOKIE_SPLIT_REGEX = /;\s/g;
var COOKIE_KEY_VALUE_REGEX = /([^=]+)=/i;
/**
 * Removes a given cookie
 * @param {string} cookieName cookie that should be removed
 */
var remove = exports.remove = function remove(cookieName) {
    if (!_isValidString(cookieName)) {
        return;
    }
    var expirationTime = new Date(0).toUTCString();
    window.document.cookie = cookieName + '=\'\'; expires=' + expirationTime;
};

/**
 * Set a given cookie with an updated value or add new cookie with value if given cookie doesn't exist.
 * @param {string} cookieName cookie that should be updated
 * @param {string} newValue the cookie value it should be updated to
 * @param {object} options (Optional) cookie setting optional fields
 * @param {object} options.expires Date object of when the cookie should expire. If not specified cookie will expire at th end of session.
 * @param {string} options.domain If not specified, defaults to the current path of the current document location.
 * @param {string} options.path If not specified, this defaults to the host portion of the current document location.
 */
var set = exports.set = function set(cookieName, newValue) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        expires = _ref.expires,
        domain = _ref.domain,
        path = _ref.path;

    if (!_isValidString(cookieName)) {
        return;
    }
    var newCookieString = cookieName + '=' + newValue;
    if (expires && expires instanceof Date) {
        newCookieString += '; expires=' + expires.toUTCString();
    }
    if (domain && _isValidString(domain)) {
        newCookieString += '; domain=' + domain;
    }
    if (path && _isValidString(path)) {
        newCookieString += '; path=' + path;
    }
    window.document.cookie = newCookieString;
};

/**
 * get a given cookie's value if exists
 * @param {string} cookieName cookie to be get
 * @return {string|null} the given cookie's value if cookie exists
 */
var get = exports.get = function get(cookieName) {
    if (!_isValidString(cookieName)) {
        return null;
    }
    var cookieValueToReturn = null;
    cookieName = cookieName.trim();
    window.document.cookie.split(COOKIE_SPLIT_REGEX).some(function (cookie) {
        var key = void 0;
        var value = void 0;
        var cookieKeyValue = cookie.match(COOKIE_KEY_VALUE_REGEX);
        if (Array.isArray(cookieKeyValue)) {
            try {
                key = decodeURIComponent(cookieKeyValue[1]);
                value = decodeURIComponent(cookie.substring(key.length + 1));
            } catch (e) {}
        }
        if (key === cookieName) {
            cookieValueToReturn = value.trim();
            return true;
        }
        return false;
    });
    return cookieValueToReturn;
};

/***/ }),

/***/ "./src/utils/ee.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** Class representing Wafer Event Emitter */
var WaferEventEmitter = function () {
    /**
     * class constructor
     * @return {void}
     */
    function WaferEventEmitter() {
        _classCallCheck(this, WaferEventEmitter);
    }
    /* Public methods */

    /**
     * responsible for initial setup
     * @return {void}
     */


    _createClass(WaferEventEmitter, [{
        key: 'init',
        value: function init() {
            this._util = {
                listeners: {}
            };
        }
        /**
         * responsible for calling functions
         * stored under listener for given name
         * @param {string} name - name for which stored listener functions should be executed
         * @param {object} data - data passed to listener function
         * @return {void}
         */

    }, {
        key: 'emit',
        value: function emit() {
            var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var listeners = this._util.listeners;


            if (!listeners) {
                return;
            }

            if (listeners[name]) {
                // yield to ensure function invocation does not break sequence
                setTimeout(function () {
                    listeners[name].forEach(function (fn) {
                        fn.call(undefined, _extends({ type: name }, data));
                    });
                }, 0);
            }
        }
        /**
         * responsible for adding function to listener for given name
         * @param {string} name - name reference within listener to which function should be added
         * @param {function} fn - function to be added
         * @return {void}
         */

    }, {
        key: 'on',
        value: function on(name, fn) {
            var listeners = this._util.listeners;


            if (!listeners || !fn || !name) {
                return;
            }
            if (!listeners[name]) {
                listeners[name] = [];
            }
            listeners[name].push(fn);
        }

        /**
         * responsible for removing function to listener for given name
         * @param {string} name - name reference within listener to which function should be removed
         * @param {function} fn - function to be removed
         * @return {void}
         */

    }, {
        key: 'removeListener',
        value: function removeListener(name, fn) {
            var listeners = this._util.listeners;


            if (!listeners) {
                return;
            }

            if (listeners[name]) {
                var index = listeners[name].indexOf(fn);
                if (index > -1) {
                    listeners[name].splice(index, 1);
                }
            }
        }

        /**
         * responsible for destroying all bound listeners
         * @return {void}
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            this._util.listeners = null;
        }
        /* End of Public methods */

    }]);

    return WaferEventEmitter;
}();

exports.default = WaferEventEmitter;
module.exports = exports['default'];

/***/ }),

/***/ "./src/utils/indexDB.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Database connection, used to create transactions for accessing and
 * manipulating the data in the database.
 */
var IDB = function () {
    /**
     * Initializes the database connection.
     * @param {object} config initial configuration
     * @param {string} config.name=wafer db name
     * @param {string} config.version=1 db version
     * @param {array} config.tables tables to created
     * @param {function} cb function invoke as part of connection lifecycle
     * @return {void}
     */
    function IDB() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$name = _ref.name,
            name = _ref$name === undefined ? 'wafer' : _ref$name,
            _ref$version = _ref.version,
            version = _ref$version === undefined ? 1 : _ref$version,
            _ref$tables = _ref.tables,
            tables = _ref$tables === undefined ? ['fetch'] : _ref$tables,
            _ref$cb = _ref.cb,
            cb = _ref$cb === undefined ? function () {} : _ref$cb;

        _classCallCheck(this, IDB);

        this._utils = {
            cb: cb,
            connection: null,
            db: null,
            name: name,
            startTime: Date.now(),
            tables: tables
        };
        var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;

        if (!indexedDB || !name || !version) {
            return;
        }
        this._utils.connection = indexedDB.open(name, version);
        this.addEventListener();
    }
    /**
     * handles subscribing to lifecycle method of connection
     * @return {void}
     */


    _createClass(IDB, [{
        key: 'addEventListener',
        value: function addEventListener() {
            var _this = this;

            var _utils = this._utils,
                cb = _utils.cb,
                connection = _utils.connection,
                startTime = _utils.startTime,
                tables = _utils.tables;


            connection.onsuccess = function (event) {
                var db = event.target.result;
                var ready = true;

                tables.some(function (table) {
                    if (!db.objectStoreNames.contains(table)) {
                        ready = false;
                        return true;
                    }
                    return false;
                });

                if (ready) {
                    _this._utils.db = db;
                    cb('success', {
                        duration: Date.now() - startTime
                    });
                }
            };
            connection.onerror = function (event) {
                _this._utils.db = null;
                cb('error', {
                    duration: Date.now() - startTime
                });
            };
            connection.onupgradeneeded = function (event) {
                var db = event.target.result;

                tables.forEach(function (tableName) {
                    var store = db.createObjectStore(tableName, {
                        keyPath: 'key'
                    });
                    // creating index helps searching within db
                    store.createIndex('key', ['cachedTime', 'key', 'ttl']);
                });
                event.target.transaction.oncomplete = function () {
                    _this._utils.db = db;
                    cb('success', {
                        duration: Date.now() - startTime
                    });
                };
            };
        }
        /**
         * get value for given key and table
         * @param {string} key key to fetch
         * @param {string} table table to fetch from
         * @param {number} config.timeout=1000 get timeout
         * @return {Promise} promise holding value
         */

    }, {
        key: 'get',
        value: function get(key, table) {
            var _this2 = this;

            var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                _ref2$timeout = _ref2.timeout,
                timeout = _ref2$timeout === undefined ? 1000 : _ref2$timeout;

            var db = this._utils.db;


            return new Promise(function (resolve, reject) {
                if (!db) {
                    reject(new Error('Connection missing'));
                    return;
                }

                if (!table) {
                    reject(new Error('Table missing'));
                    return;
                }

                var didTimeOut = false;

                var timeoutInterval = setTimeout(function () {
                    didTimeOut = true;
                    reject(new Error('Cache lookup timed out'));
                    return;
                }, timeout);

                if (!db.objectStoreNames.contains(table)) {
                    clearTimeout(timeoutInterval);
                    reject(new Error('Store does not exist : ' + table));
                    return;
                }

                var tx = void 0;

                try {
                    tx = _this2._utils.db.transaction(table, 'readonly');
                } catch (e) {
                    clearTimeout(timeoutInterval);
                    reject(e);
                    return;
                }

                tx.onerror = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    reject(event);
                };
                tx.onabort = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    reject(event);
                };

                var store = tx.objectStore(table);

                if (!store) {
                    clearTimeout(timeoutInterval);
                    reject(new Error('store doesn\'t exist for table : ' + table));
                    return;
                }
                var req = store.get(key);

                req.onsuccess = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    var res = event.target.result;

                    resolve(res);
                };
                req.onerror = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    reject(event);
                };
            });
        }
        /**
         * set data for provided table
         * @param {object} data data to be stored
         * @param {string} table table to fetch from
         * @param {number} config.timeout=1000 set timeout
         * @return {Promise} promise holding stored data
         */

    }, {
        key: 'set',
        value: function set(data, table) {
            var _this3 = this;

            var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                _ref3$timeout = _ref3.timeout,
                timeout = _ref3$timeout === undefined ? 1000 : _ref3$timeout;

            var _utils2 = this._utils,
                cb = _utils2.cb,
                db = _utils2.db;


            return new Promise(function (resolve, reject) {
                if (!db) {
                    reject(new Error('Connection missing'));
                    return;
                }

                if (!table) {
                    reject(new Error('Table missing'));
                    return;
                }

                var didTimeOut = false;
                var timeoutInterval = setTimeout(function () {
                    didTimeOut = true;
                    reject(new Error('Cache write timed out'));
                    return;
                }, timeout);

                if (!db.objectStoreNames.contains(table)) {
                    clearTimeout(timeoutInterval);
                    cb('error', {
                        action: 'deleting db',
                        message: 'Store does not exist : ' + table
                    });
                    // we have got into really bad state
                    // as we dont care about data in db, remove the db
                    // and let it be recreated again
                    // remove only as part of set
                    _this3.deleteDB().catch(function () {});
                    reject(new Error('Store does not exist : ' + table));
                    return;
                }

                var tx = void 0;

                try {
                    tx = _this3._utils.db.transaction(table, 'readwrite');
                } catch (e) {
                    clearTimeout(timeoutInterval);
                    if (e instanceof DOMException) {
                        cb('error', {
                            action: 'deleting db',
                            message: e.message
                        });
                        // we have got into really bad state
                        // as we dont care about data in db, remove the db
                        // and let it be recreated again
                        // remove only as part of set
                        _this3.deleteDB().catch(function () {});
                    }
                    reject(e);
                    return;
                }

                tx.onerror = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    reject(event);
                };
                tx.onabort = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    reject(event);
                };

                var store = tx.objectStore(table);

                if (!store) {
                    clearTimeout(timeoutInterval);
                    reject(new Error('store doesn\'t exist for table : ' + table));
                    return;
                }
                var req = store.put(data);

                req.onsuccess = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    var res = event.target.result;

                    resolve(res);
                };
                req.onerror = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    reject(event);
                };
            });
        }
        /**
         * delete key from provided table
         * @param {string} key key to delete
         * @param {string} table table to fetch from
         * @param {number} config.timeout=1000 set timeout
         * @return {Promise} promise holding result
         */

    }, {
        key: 'delete',
        value: function _delete(key, table) {
            var _this4 = this;

            var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                _ref4$timeout = _ref4.timeout,
                timeout = _ref4$timeout === undefined ? 1000 : _ref4$timeout;

            var db = this._utils.db;


            return new Promise(function (resolve, reject) {
                if (!db) {
                    reject(new Error('Connection missing'));
                    return;
                }

                if (!table) {
                    reject(new Error('Table missing'));
                    return;
                }

                var didTimeOut = false;

                var timeoutInterval = setTimeout(function () {
                    didTimeOut = true;
                    reject(new Error('Cache delete timed out'));
                    return;
                }, timeout);

                if (!db.objectStoreNames.contains(table)) {
                    clearTimeout(timeoutInterval);
                    reject(new Error('Store does not exist : ' + table));
                    return;
                }

                var tx = void 0;

                try {
                    tx = _this4._utils.db.transaction(table, 'readwrite');
                } catch (e) {
                    clearTimeout(timeoutInterval);
                    reject(e);
                    return;
                }

                tx.onerror = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    reject(event);
                };
                tx.onabort = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    reject(event);
                };

                var store = tx.objectStore(table);

                if (!store) {
                    clearTimeout(timeoutInterval);
                    reject(new Error('store doesn\'t exist for table : ' + table));
                    return;
                }
                var req = store.delete(key);

                req.onsuccess = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    var res = event.target.result;

                    resolve(res);
                };
                req.onerror = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    reject(event);
                };
            });
        }
        /**
         * clean older data
         * @param {string} table table to fetch from
         * @param {number} config.timeout=1000 set timeout
         * @param {number} config.timeDiffToDelete=1800000 set timeout (default is 30 minutes)
         * @return {Promise} promise holding stored data
         */

    }, {
        key: 'clean',
        value: function clean(table) {
            var _this5 = this;

            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                _ref5$timeout = _ref5.timeout,
                timeout = _ref5$timeout === undefined ? 10000 : _ref5$timeout,
                _ref5$timeDiffToDelet = _ref5.timeDiffToDelete,
                timeDiffToDelete = _ref5$timeDiffToDelet === undefined ? 1800000 : _ref5$timeDiffToDelet;

            var db = this._utils.db;

            var currentTime = Date.now();

            return new Promise(function (resolve, reject) {
                if (!db) {
                    reject(new Error('Connection missing'));
                    return;
                }

                if (!table) {
                    reject(new Error('Table missing'));
                    return;
                }

                var didTimeOut = false;

                var timeoutInterval = setTimeout(function () {
                    didTimeOut = true;
                    reject(new Error('Cache clean timed out'));
                    return;
                }, timeout);

                if (!db.objectStoreNames.contains(table)) {
                    clearTimeout(timeoutInterval);
                    reject(new Error('Store does not exist : ' + table));
                    return;
                }

                var tx = void 0;

                try {
                    tx = _this5._utils.db.transaction(table, 'readonly');
                } catch (e) {
                    clearTimeout(timeoutInterval);
                    reject(e);
                    return;
                }

                tx.onerror = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    reject(event);
                };
                tx.onabort = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    reject(event);
                };

                var store = tx.objectStore(table);

                if (!store) {
                    clearTimeout(timeoutInterval);
                    reject(new Error('store doesn\'t exist for table : ' + table));
                    return;
                }
                var req = store.openCursor();
                var promiseList = [];

                req.onsuccess = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    var cursor = event.target.result;

                    if (cursor) {
                        var cachedTime = cursor.value.cachedTime;


                        if (currentTime - cachedTime > timeDiffToDelete) {
                            promiseList.push(_this5.delete(cursor.key, table));
                        }
                        cursor.continue();
                    } else {
                        Promise.all(promiseList).then(function (data) {
                            resolve(data);
                        }).catch(function (err) {
                            reject(err);
                        });
                    }
                };
                req.onerror = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    reject(event);
                };
            });
        }
        /**
         * delete database
         * @return {Promise} promise
         */

    }, {
        key: 'deleteDB',
        value: function deleteDB() {
            var _this6 = this;

            var db = this._utils.db;

            var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;

            return new Promise(function (resolve, reject) {
                if (!indexedDB) {
                    reject(new Error('Connection missing'));
                    return;
                }
                if (db) {
                    db.close();
                    _this6._utils.db = null;
                }
                var name = _this6._utils.name;

                var didTimeOut = false;

                var timeoutInterval = setTimeout(function () {
                    didTimeOut = true;
                    reject(new Error('Could not delete'));
                    return;
                }, 1000);
                var req = indexedDB.deleteDatabase(name);

                req.onerror = function (event) {
                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    reject(new Error('Could not delete'));
                };
                req.onsuccess = function () {
                    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                    clearTimeout(timeoutInterval);
                    if (didTimeOut) {
                        // do nothing as promise has already timed out
                        return;
                    }
                    resolve(event.result); // should be undefined
                };
            });
        }
    }]);

    return IDB;
}();

exports.default = IDB;
module.exports = exports['default'];

/***/ }),

/***/ "./src/utils/readyQueue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var pendingReadyFnCollection = [];
    var fnsAdded = {};

    return {
        /**
         * add function with scope to ready queue
         * @param {function} name key name to avoid duplicate invocation
         * @param {function} fn function to be invoked after wafer is ready
         * @param {object} scope to bind to invoked function
         * @returns {void}
         */
        add: function add(name, fn, scope) {
            if (typeof name === 'function') {
                scope = fn;
                fn = name;
                name = undefined;
            }
            if (typeof fn !== 'function') {
                if (false) {
                    new Promise(function (resolve) {
                        require.ensure([], function (require) {
                            resolve(require('../decorators/console'));
                        });
                    }).then(function () {
                        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                            error = _ref.error;

                        error('wafer-core', 'ready can only accept function');
                    });
                }
                return;
            }
            // if fn with name was already added, do not add it again
            if (name) {
                if (fnsAdded[name]) {
                    return;
                }
                fnsAdded[name] = true;
            }
            if (window.wafer.on) {
                fn.call(scope);
                return;
            }
            pendingReadyFnCollection.push({
                scope: scope,
                fn: fn
            });
        },
        /**
         * execute all functions added to ready queue with appropriate scope
         * @returns {void}
         */
        executeAll: function executeAll() {
            pendingReadyFnCollection.forEach(function () {
                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    fn = _ref2.fn,
                    scope = _ref2.scope;

                fn.call(scope);
            });
            // clear the queue
            pendingReadyFnCollection = [];
        }
    };
}();

module.exports = exports['default'];

/***/ }),

/***/ "./src/utils/timeout.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var timeout = exports.timeout = function () {
    var timeoutMap = new Map();

    return {
        /**
         * add function with scope to ready queue
         * @param {function} fn function to execute for timeout
         * @param {number} timeout timeout value
         * @param {object} instance=instance value
         * @returns {object} timeout value
         */
        setTimeout: function (_setTimeout) {
            function setTimeout(_x, _x2, _x3) {
                return _setTimeout.apply(this, arguments);
            }

            setTimeout.toString = function () {
                return _setTimeout.toString();
            };

            return setTimeout;
        }(function (fn, timeout, instance) {
            var that = instance || undefined;

            if (!that) {
                return setTimeout(fn, timeout);
            }
            if (!timeoutMap.has(that)) {
                timeoutMap.set(that, new Map());
            }
            var fnTimeout = setTimeout(function () {
                var args = Array.prototype.slice.call(arguments);

                timeoutMap.get(that).delete(fnTimeout);
                fn.apply(this, args);
            }, timeout);
            timeoutMap.get(that).set(fnTimeout, fnTimeout);
            return fnTimeout;
        }),
        /**
         * clear all timeouts
         * @returns {void}
         */
        clearAllTimeout: function clearAllTimeout() {
            if (!timeoutMap || !timeoutMap.size) {
                return;
            }
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = timeoutMap.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var val = _step.value;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = val.values()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var fnTimeout = _step2.value;

                            clearTimeout(fnTimeout);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            timeoutMap.clear();
        },

        /**
         * clear timeout for instance
         * @param {object} instance=instance value
         * @returns {void}
         */
        clearTimeoutForInstance: function clearTimeoutForInstance(instance) {
            var timeInstanceMap = timeoutMap.get(instance);

            if (!timeInstanceMap || !timeInstanceMap.size) {
                return;
            }
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = timeInstanceMap[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var fnTimeout = _step3.value;

                    clearTimeout(fnTimeout);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            timeoutMap.get(instance).clear();
        },
        /**
         * clear specific timeout for given instance
         * @param {object} fnTimeout=timeout value
         * @param {object} instance=instance value
         * @returns {void}
         */
        clearTimeout: function (_clearTimeout) {
            function clearTimeout(_x4, _x5) {
                return _clearTimeout.apply(this, arguments);
            }

            clearTimeout.toString = function () {
                return _clearTimeout.toString();
            };

            return clearTimeout;
        }(function (fnTimeout, instance) {
            var that = instance || undefined;
            var mapKey = timeoutMap.get(that);

            if (!mapKey) {
                clearTimeout(fnTimeout);
                return;
            }
            var fnTimeoutVal = mapKey.get(fnTimeout);

            clearTimeout(fnTimeoutVal);
            timeoutMap.get(that).delete(fnTimeout);
        })
    };
}();

/***/ }),

/***/ "./src/utils/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var FIRST_CACHE_LOOKUP_TIMEOUT = 1000;
var FETCH_QUERIES_TO_EXCLUDE_FOR_CACHING = ['rid', 'crumb', 'subscrumb'];
var FETCH_ALLOWED_CREDENTIALS = { omit: 1, 'same-origin': 1, include: 1 };
var FETCH_DEFAULT_CREDENTIALS = 'same-origin';

/**
 * remove query from url
 * @param {string} url url string
 * @param {string} name query key name to be removed
 * @return {string} final string
 */
var removeParameterFromUrl = exports.removeParameterFromUrl = function removeParameterFromUrl() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var name = arguments[1];

    return url.replace(new RegExp('[?&]' + name + '=[^&#]*(#.*)?$'), '$1').replace(new RegExp('([?&])' + name + '=[^&]*&'), '$1');
};

/**
 * Covert params to url
 * @param {object} obj for url params
 * @return {string} urlfied string
 */
var urlify = exports.urlify = function urlify(obj) {
    return Object.keys(obj).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
    }).join('&');
};

/**
 * Fetch data. Supports off-line mode
 * - Its enabled by default
 * - Has following strategies for caching (when enabled)
 *     - cacheFirst
 *         - Attempt fetching from cache with low timeout and serve cache(only if not stale)
 *             - If cache is stale
 *                 - fetch from network and populate cache
 *                 - If network fails, serve stale data
 *             - If no cache exists, fetch from network and populate cache
 *             - If first cache lookup and network failed, try cache again with high timeout (Note: will serve stale cache)
 *     - networkFirst
 *         - Fetch from network
 *         - If network fails
 *             - Look into cache
 *             - If cache exists, serve cache (Note: will serve stale cache)
 * @param {url} url to fetch data for
 * @param {number} config.cache=1 enabled by default. However, caching will not work until indexDB connection is setup.
 * @param {number} config.cacheKey cache key to be used. Optional field.
 * @param {number} config.cacheTtl=60 cache ttl. Default to 1 minute
 * @param {number} config.paramsToNotCache={} params to not cache
 * @param {number} config.timeout=6000 fetch timeout
 * @param {string} config.body stringified json
 * @param {string} config.cacheStrategy=networkFirst caching strategy. Default to cacheFirst. Works only for cache=1.
 * @param {string} config.credentials=same-origin override credentials for fetch to send cookies. Default to same-origin
 * @param {string} config.importance=auto [high|low] - browser priority hint - https://developers.google.com/web/updates/2019/02/priority-hints
 * @param {string} config.method=GET method to be used
 * @param {string} config.mode override mode for fetch to support no-cors
 * @param {string} config.useRid use rid from wafer config
 * @return {object} promise with data
 */
var fetchWithCache = exports.fetchWithCache = function fetchWithCache(url) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        body = _ref.body,
        _ref$cache = _ref.cache,
        cache = _ref$cache === undefined ? 1 : _ref$cache,
        cacheKey = _ref.cacheKey,
        _ref$cacheStrategy = _ref.cacheStrategy,
        cacheStrategy = _ref$cacheStrategy === undefined ? 'networkFirst' : _ref$cacheStrategy,
        _ref$cacheTtl = _ref.cacheTtl,
        cacheTtl = _ref$cacheTtl === undefined ? 60 : _ref$cacheTtl,
        _ref$clientHeaders = _ref.clientHeaders,
        clientHeaders = _ref$clientHeaders === undefined ? {} : _ref$clientHeaders,
        _ref$credentials = _ref.credentials,
        credentials = _ref$credentials === undefined ? FETCH_DEFAULT_CREDENTIALS : _ref$credentials,
        importance = _ref.importance,
        _ref$method = _ref.method,
        method = _ref$method === undefined ? 'GET' : _ref$method,
        mode = _ref.mode,
        _ref$paramsToNotCache = _ref.paramsToNotCache,
        paramsToNotCache = _ref$paramsToNotCache === undefined ? {} : _ref$paramsToNotCache,
        retries = _ref.retries,
        _ref$timeout = _ref.timeout,
        timeout = _ref$timeout === undefined ? 6000 : _ref$timeout,
        _ref$useRid = _ref.useRid,
        useRid = _ref$useRid === undefined ? true : _ref$useRid;

    return new Promise(function (resolve, reject) {
        var startTime = Date.now();
        var extraParams = urlify(paramsToNotCache);
        var urlAppendToken = url.indexOf('?') === -1 ? '?' : '&';
        var urlToFetch = extraParams ? url + urlAppendToken + extraParams : url;

        if (!cacheKey) {
            cacheKey = url;

            FETCH_QUERIES_TO_EXCLUDE_FOR_CACHING.forEach(function (type) {
                cacheKey = removeParameterFromUrl(cacheKey, type);
            });
        }
        if (!credentials && !FETCH_ALLOWED_CREDENTIALS[credentials]) {
            credentials = FETCH_DEFAULT_CREDENTIALS;
        }
        var shouldCache = cache;
        var didTimeOut = false;
        var cachedData = void 0;
        var cachePromise = void 0;
        var resolved = false;

        if (body) {
            try {
                body = JSON.stringify(JSON.parse(body));
                method = method === 'GET' ? 'POST' : method;
                shouldCache = false; // dont cache POST, PUT, DELETE requests
            } catch (err) {
                body = {};
                console.error('JSON parsing failed for', url, err);
            }
        }

        var timeoutInterval = setTimeout(function () {
            var endTime = Date.now();

            didTimeOut = true;
            // serve from cache if available
            if (cachedData) {
                resolve(Object.assign({}, cachedData, {
                    _fetchMeta: {
                        duration: endTime - startTime,
                        source: 'CACHE_IS_STALE'
                    }
                }));
                return;
            }
            reject(new Error('Request timed out for timeout value ' + timeout + ' having startTime ' + startTime + ' and endTime ' + endTime));
        }, timeout);

        if (shouldCache && window.wafer.db && cacheStrategy === 'cacheFirst') {
            // Use the URL as the cache key
            cachePromise = window.wafer.db.get(cacheKey, 'fetch', {
                timeout: FIRST_CACHE_LOOKUP_TIMEOUT // keep initial cache lookup short
            }).then(function (result) {
                if (!result) {
                    return;
                }
                var ttl = result.ttl,
                    value = result.value,
                    cachedTime = result.cachedTime;

                var age = (Date.now() - cachedTime) / 1000;

                try {
                    cachedData = JSON.parse(value);
                } catch (e) {}
                if (age < ttl) {
                    clearTimeout(timeoutInterval);

                    if (!didTimeOut) {
                        resolved = true;
                        resolve(Object.assign({}, cachedData, {
                            _fetchMeta: {
                                duration: Date.now() - startTime,
                                source: 'CACHE'
                            }
                        }));
                    }
                }
                // we don't clean old key to support offline mode
            }).catch(function (err) {
                // do nothing
            });
        } else {
            cachePromise = Promise.resolve(false);
        }
        cachePromise.then(function () {
            // don't proceed if previous promise resolved successfully
            if (resolved) {
                return;
            }
            var headers = new Headers();
            var _window$wafer$base = window.wafer.base,
                _window$wafer$base$ad = _window$wafer$base.adLiteConfig,
                adLiteConfig = _window$wafer$base$ad === undefined ? {} : _window$wafer$base$ad,
                fetchHeaders = _window$wafer$base.fetchHeaders,
                rid = _window$wafer$base.rid;

            var _ref2 = adLiteConfig || {},
                adLite = _ref2.adLite,
                subscrumb = _ref2.subscrumb;

            if (mode !== 'cors') {
                for (var key in fetchHeaders) {
                    if (fetchHeaders.hasOwnProperty(key)) {
                        headers.set(key, fetchHeaders[key]);
                    }
                }
                // added only for adLite subcriptions users
                if (adLite && subscrumb) {
                    urlToFetch += urlAppendToken + 'adLite=' + adLite + urlAppendToken + 'subscrumb=' + encodeURIComponent(subscrumb);
                }
            }
            if (useRid && rid && urlToFetch.indexOf('rid=') === -1) {
                urlToFetch += urlAppendToken + 'rid=' + rid;
            }
            // add perf=1 to fetch urls if ___debugContent is turned on
            if (window.wafer.___debugContent && urlToFetch.indexOf('perf=') === -1) {
                urlToFetch += urlAppendToken + 'perf=1';
            }
            for (var _key in clientHeaders) {
                if (clientHeaders.hasOwnProperty(_key)) {
                    headers.set(_key, clientHeaders[_key]);
                }
            }
            if ((method === 'POST' || method === 'PUT' || method === 'DELETE') && !headers.has('Content-Type')) {
                headers.set('Content-Type', 'application/json');
            }

            if (retries && mode !== 'cors') {
                headers.set('x-wf-retry-count', retries);
            }
            var fetchAttribs = {
                credentials: credentials,
                headers: headers,
                method: method
            };

            if (mode) {
                fetchAttribs.mode = mode;
            }
            if (body) {
                fetchAttribs.body = body;
            }
            if (importance) {
                fetchAttribs.importance = importance;
            }
            fetch(urlToFetch, fetchAttribs).then(function (response) {
                clearTimeout(timeoutInterval);
                if (didTimeOut) {
                    // do nothing as promise has already timed out
                    return;
                }
                var status = response.status;


                if (status >= 200 && status <= 299 && (method === 'PUT' || method === 'DELETE')) {
                    var _fetchMeta = {
                        duration: Date.now() - startTime,
                        source: 'NETWORK_WITHOUT_CACHE'
                    };

                    response.json().then(function (data) {
                        resolve(_extends({}, data, {
                            _fetchMeta: _fetchMeta
                        }));
                    }).catch(function () {
                        resolve({
                            _fetchMeta: _fetchMeta
                        });
                    });
                    return;
                }
                if (status === 200) {
                    var ct = response.headers.get('Content-Type');

                    if (shouldCache && window.wafer.db && cacheTtl && ct && ct.match(/application\/json/i)) {
                        var cachedTime = Date.now();

                        // There is a .json() instead of .text() but
                        // we're going to store it in indexdb as
                        // string anyway.
                        // If we don't clone the response, it will be
                        // consumed by the time it's returned
                        response.clone().text().then(function (content) {
                            window.wafer.db.set({
                                ttl: cacheTtl,
                                key: cacheKey,
                                value: content,
                                cachedTime: cachedTime
                            }, 'fetch', {
                                timeout: timeout
                            }).catch(function (e) {
                                // do nothing
                            });
                            return true;
                        });
                    }
                    return response.json().then(function (data) {
                        // if data is not object, throw error
                        if (Object(data) !== data) {
                            throw new Error('Malformed response');
                            return;
                        }
                        resolve(Object.assign({}, data, {
                            _fetchMeta: {
                                duration: Date.now() - startTime,
                                source: shouldCache ? cachedData ? 'NETWORK_AS_CACHE_IS_EXPIRED' : 'NETWORK' : 'NETWORK_WITHOUT_CACHE'
                            }
                        }));
                    }).catch(function (e) {
                        throw new Error('Malformed response');
                        return;
                    });
                } else if (status === 204) {
                    // For 204 status, we throw different error and ensure the request
                    // is not served from cache
                    shouldCache = false;
                    cachedData = null;
                    throw new Error('No Content');
                    return;
                } else if (mode === 'no-cors' && status === 0) {
                    resolve(Object.assign({
                        html: ''
                    }, {
                        _fetchMeta: {
                            duration: Date.now() - startTime,
                            source: shouldCache ? cachedData ? 'NETWORK_AS_CACHE_IS_EXPIRED' : 'NETWORK' : 'NETWORK_WITHOUT_CACHE'
                        }
                    }));
                    return true;
                } else {
                    // Non 200 requests do not go to catch in older browsers
                    throw new Error(status === 404 ? 'Not found' : 'Malformed response');
                    return;
                }
            }).catch(function (err) {
                // Rejection already happened with setTimeout
                if (didTimeOut) {
                    return;
                }
                clearTimeout(timeoutInterval);
                // serve from cache if available
                if (cachedData) {
                    resolve(Object.assign({}, cachedData, {
                        _fetchMeta: {
                            duration: Date.now() - startTime,
                            source: 'CACHE_IS_STALE'
                        }
                    }));
                } else if (shouldCache) {
                    if (!window.wafer.db) {
                        reject(err);
                        return;
                    }
                    // check cache again with higher timeout
                    window.wafer.db.get(cacheKey, 'fetch', {
                        timeout: timeout
                    }).then(function (result) {
                        if (!result) {
                            reject(err);
                            return;
                        }
                        var ttl = result.ttl,
                            value = result.value,
                            cachedTime = result.cachedTime;

                        var age = (Date.now() - cachedTime) / 1000;

                        try {
                            cachedData = JSON.parse(value);
                        } catch (e) {
                            // TODO: Add error event
                        }

                        resolve(Object.assign({}, cachedData, {
                            _fetchMeta: {
                                duration: Date.now() - startTime,
                                source: age < ttl ? 'CACHE_SECOND_ATTEMPT' : 'CACHE_SECOND_ATTEMPT_STALE'
                            }
                        }));
                    }).catch(function (cacheErr) {
                        reject(cacheErr);
                    });
                } else {
                    reject(err);
                }
            });
        });
    }).then(function (data) {
        var _data$assets = data.assets,
            assets = _data$assets === undefined ? {} : _data$assets;
        var _assets$css = assets.css,
            css = _assets$css === undefined ? [] : _assets$css;


        if (!css) {
            return data;
        }
        return Promise.all(css.map(function (css) {
            var value = css.value;
            if (css.cdnOrigin === '') {
                value = location.origin + value;
            }
            return window.wafer.base._loadAsset(value, 'css');
        })).then(function () {
            return data;
        });
    });
};

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./polyfills/svg-polyfill.js");
__webpack_require__("../../node_modules/core-js/es/array/from.js");
__webpack_require__("../../node_modules/core-js/es/map/index.js");
__webpack_require__("../../node_modules/core-js/es/promise/index.js");
__webpack_require__("../../node_modules/core-js/es/symbol/index.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.assign.js");
__webpack_require__("../../node_modules/eligrey-classlist-js-polyfill/classList.js");
__webpack_require__("./polyfills/fetch-polyfill.js");
module.exports = __webpack_require__("./src/entry.js");


/***/ })

/******/ });
});
//# sourceMappingURL=wf-core-1.65.1.raw.js.map